(($, window, undefined) => {
    if (window.mg === undefined)
        window.mg = {};

    const _ = window.mg;

    const abstractView = (target, compEntry) => {
        target.compEntry = compEntry;
    };

    class _ViewPlayers {
        constructor(compEntry) {
            abstractView(this, compEntry);

            this.$wrapper = $('#comp-entry-view-players', this.compEntry.$target);
        }

        render() {
            const requestData = this.compEntry.data.requestData;

            $('.entry-list', this.$wrapper).empty();
            $('.team-details > .choices', this.$wrapper).remove();

            if (requestData) {
                if (this.compEntry.asTeam) {
                    const team = requestData.Teams ? requestData.Teams[0] : null;

                    if (team) {
                        if (team.TeamEntries && team.TeamEntries.length) {
                            team.TeamEntries.forEach((v) => {
                                let entry = v.EntryID && requestData.Entries && requestData.Entries.find((vE) => vE.ID === v.EntryID);

                                if (entry === null && team.ID === null && requestData.Entries && requestData.Entries.length === 1)
                                    entry = requestData.Entries[0]; // For the initial signup we may not be able to map TeamEntries to Entries, as we may not have an ID. Fallback to the first entry.

                                entry && this._renderPlayer(entry);
                            });
                        } else {
                            requestData.Entries && requestData.Entries.forEach((v) => {
                                this._renderPlayer(v);
                            });
                        }

                        this._renderTeam(team, requestData.Entries);
                    }
                } else {
                    requestData.Entries && requestData.Entries.forEach((v) => {
                        this._renderPlayer(v);
                    });
                }
            }

            // starting validation register
            const fvFields = this.compEntry.validation.fv.getFields();

            Object.keys(fvFields)
                .filter((v) => v.indexOf('{PARTICIPANT}') !== -1)
                .forEach((v) => {
                    this.compEntry.validation.fv.removeField(v);
                });

            const playersFvFields = $('[name]', this.$wrapper)
                .filter((i, e) => Object.keys(e.dataset).some((v) => v.startsWith('fv')))
                .get();

            playersFvFields
                .forEach((v) => {
                    this.compEntry.validation.fv.addField(
                        v.name,
                        this.compEntry.validation.fv.plugins.declarative.parseElement(v)
                    );
                });
        }

        addPlayer(golfId, ...fields) {
            const funcAddPlayer = (golfId) => {
                golfId = golfId.trim();

                if (!golfId)
                    return;

                const entries = this.compEntry.data.requestData.Entries;

                if (entries.some((v) => v.MemberID == golfId)) {
                    _.ui.errormodal({
                        html  : '<div>' + _.translations.ThisPlayerAlreadyExists + '</div>',
                        title : _.translations.Error
                    });

                    return;
                }

                const o = {
                    competitionID : this.compEntry.data.requestData.ID,
                    golfIDs       : entries.map((v) => v.MemberID).concat([golfId]),
                    asTeam        : this.compEntry.asTeam
                };

                const pleaseWait = _.ui.showPleaseWaitModal();

                _.ajax.post('?handler=AddPlayer', o, true)
                .fail((jqXHR, textStatus, errorThrown) => {
                    pleaseWait.close();

                    _.ui.errormodal({
                        html  : '<div>' + errorThrown + '</div>',
                        title : _.translations.Error
                    });
                })
                .done((data) => {
                    pleaseWait.close();

                    data = this._checkRequestResponse(data);

                    if (!data)
                        return;

                    this.compEntry.data.requestData = data;

                    data.Entries
                        .forEach((v) => {
                            this._renderPlayer(v);
                        });

                    // Add player: Pre-select a class if the team only fits one class
                    // Remove player: Remove the class selection if the team no longer fits the selected class

                    var $ddlClass = $('#ddlClass');
                    if ($ddlClass.length) { // Attempt to pre-select a class (also if the user has already selected a class. The class is only changed if they only fit in 1 class).
                        var availableClasses = [];

                        this.compEntry.data.requestData.Teams.forEach((v) => {
                            var classes = this._getParticipantClasses(v, true); // This time we don't specify ignoreStatus, as we only want the classes the team is not invalid in

                            classes && classes.forEach((vC) => {
                                availableClasses.push(vC);
                            });
                        });

                        if (availableClasses && availableClasses.length === 1) { // The team only fits in one class, auto-select this class
                            $ddlClass.val(availableClasses[0].ID);
                        }
                    }

                    // TODO - We might want to resolve team name here as well
                    var team = this.compEntry.data.requestData.Teams ? this.compEntry.data.requestData.Teams[0] : null;
                    this._renderTeamName(team);

                    $ddlClass.trigger('change'); // Trigger change to recalculate any errors shown here
                    $('#ddl-addplayer-favs, #txt-addplayer-golfid, #txt-addplayer-firstname, #txt-addplayer-lastname', this.$wrapper).val('');
                    $(`.add-player-search-result-wrapper div[data-golfid="${golfId}"]`, this.$wrapper).remove();

                    _.ui.select.get($('#ddl-addplayer-favs', this.$wrapper)).sp.refresh();
                });
            };

            if (fields.length) {
                this.compEntry.validateFields(fields)
                .then((status) => {
                    if (status === FormValidation.Status.Valid)
                        funcAddPlayer(golfId);
                });
            } else {
                funcAddPlayer(golfId);
            }
        }

        removePlayer(golfId) {
            const newGolfIDs = this.compEntry.data.requestData.Entries.filter((v) => {
                return v.MemberID !== golfId || v.IsSelf;
            }).map((v) => v.MemberID);

            const o = {
                competitionID : this.compEntry.data.requestData.ID,
                golfIDs       : newGolfIDs,
                asTeam        : this.compEntry.asTeam
            };

            const pleaseWait = _.ui.showPleaseWaitModal();

            _.ajax.post('?handler=AddPlayer', o, true)
            .fail((jqXHR, textStatus, errorThrown) => {
                pleaseWait.close();

                _.ui.errormodal({
                    html  : '<div>' + errorThrown + '</div>',
                    title : _.translations.Error
                });
            })
            .done((data) => {
                pleaseWait.close();

                data = this._checkRequestResponse(data);

                if (!data)
                    return;

                this.compEntry.data.requestData = data;

                data.Entries
                    .forEach((v) => {
                        this._renderPlayer(v);
                    });

                var $ddlClass = $('#ddlClass');
                var selectedClass = parseInt($('#ddlClass').val());
                if ($ddlClass.length && selectedClass) { // We want to clear the class selection if the user no longer fits in the selected class
                    var availableClasses = [];
                    var classFound = false;

                    this.compEntry.data.requestData.Teams.forEach((v) => {
                        var classes = this._getParticipantClasses(v, true); // This time we don't specify ignoreStatus, as we only want the classes the team is not invalid in

                        classes && classes.forEach((vC) => {
                            availableClasses.push(vC);
                        });
                    });

                    availableClasses && $.each(availableClasses, function (k, v) {
                        if (v.ID === selectedClass) {
                            classFound = true;
                            return false; // Break the v-loop
                        }
                    });

                    if (!classFound) {
                        $ddlClass.val(null); // Clear the selection
                    }
                }

                // TODO - We might want to resolve team name here as well
                var team = this.compEntry.data.requestData.Teams ? this.compEntry.data.requestData.Teams[0] : null;
                this._renderTeamName(team);

                $ddlClass.trigger('change'); // Trigger change to recalculate any errors shown here
                $(`.entry[data-golfid="${golfId}"]`, this.$wrapper).remove();
            });
        }

        searchPlayer(clubId, firstName, lastName, ...fields) {
            const funcSearchPlayer = (clubId, firstName, lastName) => {
                firstName = firstName.trim();
                lastName  = lastName.trim();

                const pleaseWait = _.ui.showPleaseWaitModal();

                if (!clubId || firstName.length <= 1 || lastName.length <= 1) {
                    pleaseWait.close();
                    return;
                }

                $('.add-player-search-result-wrapper', this.$wrapper).empty();

                _.ajax.post('?handler=SearchPlayer', { clubId, firstName, lastName })
                .done((data) => {
                    pleaseWait.close();

                    if (data.Error) {
                        _.ui.errormodal({
                            html  : '<div>' + data.Error + '</div>',
                            title : _.translations.Error
                        });

                        return;
                    }

                    let html = data.Players.map((v, i) => {
                        return `<div class="row align-items-lg-center ${i == 0 ? 'mt-3' : 'mt-2'}" data-golfid="${v.GolfID}">` +
                            `<div class="col-lg-3">${v.GolfID}</div>` +
                            `<div class="col-lg-3">${v.FullName}</div>` +
                            `<div class="col-lg-3">${v.ActualHCP}</div>` +
                            `<div class="col-lg-auto ml-auto">` +
                                `<button type="button" class="btn btn-primary btn-block" onclick="mg.pages.competition.entry.views.players.addPlayer('${v.GolfID}')">${_.translations.Add}</button>` +
                            `</div>` +
                        `</div>`;
                    });

                    $('.add-player-search-result-wrapper', this.$wrapper).empty().html(html);
                });
            };

            if (fields.length) {
                this.compEntry.validateFields(fields)
                .then((status) => {
                    if (status === FormValidation.Status.Valid)
                        funcSearchPlayer(clubId, firstName, lastName);
                });
            } else {
                funcSearchPlayer(clubId, firstName, lastName);
            }
        }

        toggleAddPlayer(id) {
            if (!id) {
                $('.add-player > .collapse', this.$wrapper).collapse('hide');
                return;
            }

            $(id, this.$wrapper).collapse('toggle');
        }

        _renderPlayer(player) {
            let classes = !this.compEntry.asTeam ? this._getParticipantClasses(player) : [];
            let tees    = this._getPlayerTees(player);
            let html    = this._getPlayerHTML(player, classes, tees);

            const idTeeTime         = 'ddlTeeTimeWish'; // Same ID for entry and team, as the value is always stored on entries
            const idSelectTee       = 'ddlTee_' + player.MemberID;
            const idMainClass       = this.compEntry.data.competition.ClassSetup.EnableMultiClass ? 'ddlMainClass' : 'ddlClass'; // Same ID for entry and team (unless it's multiclass), as they use the same dropdown (in a team signup you cannot select class for entries, and vice versa)
            const idOtherClasses    = 'ddlOtherClasses-wrapper';

            html += this._getChoicesHTML(
                !this.compEntry.asTeam ? this._getTeeTimeHTML(player, idTeeTime) : '',
                !this.compEntry.asTeam ? this._getMainClassHTML(player, idMainClass) : '',
                !this.compEntry.asTeam ? this._getOtherClassesHTML(player, idOtherClasses) : '',
                { html: this._getTeeHTML(player, idSelectTee) }
            );

            html = `<div class="entry" data-golfid="${player.MemberID}">${html}</div>`;

            $('.entry-list', this.$wrapper).find('[data-golfid="' + player.MemberID + '"]').remove().end().append(html); // Remove any existing elements for this player, and append a new

            if ($('#' + idMainClass).length) {
                $('#' + idMainClass).on('change', (e) => {
                    this._ddlClassOnChange(e.target, player);
                });

                this._ddlClassOnChange($('#' + idMainClass)[0], player, true);
            }
            else if (this.compEntry.data.competition.Request.TeeWishesOpenFor === 2) {
                this._updateAvailableTees();
            }
        }

        _renderTeam(team, entries) {
            let html = '';

            const idTeeTime = 'ddlTeeTimeWish'; // Same ID for entry and team, as the value is always stored on entries
            const idClass   = 'ddlClass'; // Same ID for entry and team, as they use the same dropdown (in a team signup you cannot select class for entries, and vice versa)

            html += this._getChoicesHTML(
                this._getTeeTimeHTML(team, idTeeTime, entries),
                this._getMainClassHTML(team, idClass, true)
            );

            $('.team-details .error-message', this.$wrapper).before(html); // Insert the HTML before the .error-message

            let $txtTeamName = $('#txtTeamName');
            let $lblTeamName = $('#lblTeamName');

            $txtTeamName.length && $txtTeamName.val(team.Name);
            $lblTeamName.length && this._renderTeamName(team, $lblTeamName);

            if ($('#' + idClass).length) {
                $('#' + idClass).on('change', (e) => {
                    this._ddlTeamClassOnChange(e.target, team);
                });
            }
            else if (this.compEntry.data.competition.Request.TeeWishesOpenFor === 2) {
                this._updateAvailableTees();
            }
        }

        _renderTeamName(team, $lblTeamName) {
            if (!team)
                return;

            if ($lblTeamName === undefined)
                $lblTeamName = $('#lblTeamName');

            $lblTeamName.length && $lblTeamName.html(!team.ManualTeamNaming ? (_.translations.TeamName + ': ' + (team.Name || '-')) : '');
        }

        _getPlayerHTML(player, classes, tees) {
            let className = '';
            if (player.MainClassID && !this.compEntry.asTeam && (classes === null || classes.length < 2)) {
                classes.forEach((v) => {
                    if (v.ID === player.MainClassID) {
                        className = v.Name;
                        return false; // Break the v-loop
                    }
                });
            }

            var showHCPStatus = this.$wrapper.data().showhcpstatus === 1;
            var hcpStatusContent = showHCPStatus ? (player.HandicapStatus === 2 ? _.translations.Yes : _.translations.No) : '';
            var hcpStatusColInnerClass = 'd-flex h-100 justify-content-center' + (this.compEntry.asTeam ? ' align-items-center' : ''); // When we show the Remove Player content, it looks best when this content is aligned vertically like that. Otherwise, it looks best that it alins with the top row.

            return `<div class="row">` +
                `<div class="col-10 col-lg-${showHCPStatus ? 8 : 10}">` +
                    `<div class="row">` +
                        `<div class="col-6 col-lg-4 order-lg-1">${player.FirstName} ${player.LastName}</div>` +
                        `<div class="col-6 col-lg-4 order-lg-2">${player.FormattedHCP}</div>` +
                        `<div class="col-6 col-lg-4 order-lg-4">${player.MemberID}</div>` +
                        `<div class="col-6 col-lg-4 order-lg-5">${player.ClubName}</div>` +
                        (player.Tee && (tees === null || tees.length < 2) ? `<div class="col-6 col-lg-4 order-lg-3">${_.translations.Tee}: ${player.Tee}</div>` : `<div class="d-none d-lg-block col-lg-4 order-lg-3"></div>`) + // KJ 2023-03-06: Upon request from Mikaela we're reserving this space in desktop when no content is shown here, to keep the other columns in their place (e.g. GolfID underneath player name).
                        (className ? `<div class="col-6 col-lg-4 order-lg-6">${_.translations.Class}: ${className}</div>` : ``) +
                        (showHCPStatus ? `<div class="col-6 d-lg-none"><span class="d-lg-none">${_.translations.HandicapStatusActive_Short}: </span><span>${hcpStatusContent}</span></div>` : ``) +
                    `</div>` +
                `</div>` +
                (showHCPStatus ? `<div class="col-2 d-none d-lg-block"><span class="${hcpStatusColInnerClass}">${hcpStatusContent}</span></div>` : ``) +
                `<div class="col-2">${!player.IsSelf && !player.ID ? `<div class="text-right remove-player"><a href="javascript:void(0)" onclick="mg.pages.competition.entry.views.players.removePlayer('${player.MemberID}')"><i class="icon icon-minus"></i>${_.translations.Remove}</a></div>` : ``}</div>` +
            `</div>`;
        }

        _getChoicesHTML(...choices) {
            if (!choices.length || !choices.some((v) => !!v))
                return '';

            choices = choices.filter((v) => !!v);

            return `<div class="choices">` +
                `<div class="row">` +
                    choices.map((v, i) => `<div class="col-12 col-lg${v.useRemainingWidthIfLast && i === choices.length - 1 ? '' : '-3'}"><div class="form-group mb-0 h-100">${v.html !== undefined ? v.html : v}</div></div>`).join('') + // The h-100 is to allow texts, i.e. team class text to align properly with the rest of the content
                `</div>` +
            `</div>`;
        }

        _getTeeTimeHTML(participant, id, entries) {
            if (!this.$wrapper.data().request || !this.$wrapper.data().request.AllowEarlyLateStart)
                return '';

            let selected = participant.Request ? participant.Request.TeeTime : entries && entries.length > 0 && entries[0].Request ? entries[0].Request.TeeTime : null; // TeeTime is stored on entries

            return `<div class="bold">${_.translations.TeeTimeWish}</div><select id="${id}" name="${id}" class="custom-select">` +
                `<option value=""></option>` +
                this.$wrapper.data().teetimewishes.map((v) => `<option value="${v.Key}" ${v.Key === selected ? 'selected="selected"' : ''}>${v.Value}</option>`).join('') +
            `</select>`;
        }

        _getMainClassHTML(participant, id, isTeam) {
            if (this.compEntry.data.competition.ClassSetup && this.compEntry.data.competition.ClassSetup.SameSize)
                return '';

            let options = [];
            let classes = this._getParticipantClasses(participant, isTeam, isTeam); // We pass the isTeam variable as the ignoreStatus variable, as we want to allow users to select classes they are invalid in, in order to see a message why they cannot select that class
            const enableMultiClass = this.compEntry.data.competition.ClassSetup.EnableMultiClass;

            classes && classes.forEach((v) => {
                options.push('<option value="' + v.ID + '"' + (this.compEntry.isSignedUp && v.Status === 0 && (!enableMultiClass || v.IsPrimary) ? ' selected="selected"' : '') + '>' + v.Name + '</option>');
            });

            if (options.length > 1) {
                let title = '<div class="bold">' + (enableMultiClass ? _.translations.MainClass : _.translations.Class) + '</div>';

                return title + `<select id="${id}" name="${id}" class="custom-select" data-fv-not-empty="true">` +
                    `<option value=""></option>` +
                    options.join('') +
                `</select>`;
            }
            else if (classes.length === 1 && isTeam) { // We only want to display the class name here in team signup, as the class name should otherwise already be listed with the player info
                return `<div class="h-100 d-flex align-items-center"><div>${_.translations.Class}: ${classes[0].Name}</div></div>`;
            }

            return '';
        }

        _getOtherClassesHTML(player, id) {
            return this.compEntry.data.competition.ClassSetup && this.compEntry.data.competition.ClassSetup.EnableMultiClass ? '<div class="bold">' + _.translations.OtherClasses + '</div><div id="' + id + '"></div>' : ''; // Empty placeholder
        }

        _getTeeHTML(player, idSelectTee) {
            if (!this.$wrapper.data().tees)
                return '';

            let $existing = $('#' + idSelectTee);
            let selected = $existing.length ? $existing.val() : (player.Request ? player.Request.TeeGUID : null);
            let title = `<div class="bold">${_.translations.Tee}</div>`;

            return title + `<select id="${idSelectTee}" name="${idSelectTee}" class="custom-select">` +
                `<option value="">${_.translations.SelectTee}</option>` +
                this.$wrapper.data().tees.map((v) => {
                    if (player.Gender == 0 && !v.AllowFemale)
                        return '';

                    if (player.Gender == 1 && !v.AllowMale)
                        return '';

                    return `<option value="${v.GUID}" ${v.GUID === selected ? 'selected="selected"' : ''} data-text="${v.Name}">${v.Name}</option>`;
                }).join('') +
                `<select>`;
        }

        _getParticipantClasses(participant, isTeam, ignoreStatus) {
            let classes = [];
            let comparisonType = isTeam ? 2 : 1;

            this.compEntry.data.requestData.Classes && this.compEntry.data.requestData.Classes.forEach((v) => {
                if (v.Type === comparisonType && ((isTeam && v.ExternalID === null) || (!isTeam && v.ExternalID === participant.MemberID)) && (ignoreStatus || v.Status === 0 || v.Status === 1 || v.Status === 3)) { // Status Entrant, Competitor or Available
                    classes.push(v);
                }
            });

            if (!isTeam && classes.length > 1) {
                var filteredClasses = [];
                let competitionClasses = this.compEntry.data.competition ? this.compEntry.data.competition.Classes : null;

                classes.forEach((v) => {
                    var addClass = true;
                    var competitionClass = null;

                    competitionClasses && $.each(competitionClasses, function (kC, vC) {
                        if (vC.ID === v.ID) {
                            competitionClass = vC;
                            return false; // Break the vC-loop
                        }
                    });

                    if (v.Status === 3 && competitionClass && competitionClass.Type === 2) {
                        addClass = false; // We don't include Availble team classes for players, as the user shouldn't be allowed to select a team class as an individual
                    }

                    if (addClass) {
                        filteredClasses.push(v);
                    }
                });

                classes = filteredClasses;
            }

            return classes;
        }

        _getPlayerTees(player) {
            var tees = [];

            this.$wrapper.data().tees && this.$wrapper.data().tees.forEach((v) => {
                if ((player.Gender === 0 && v.AllowFemale) || (player.Gender === 1 && v.AllowMale)) {
                    tees.push(v);
                }
            });

            return tees;
        }

        _ddlClassOnChange(element, participant, isInit) {
            if (this.compEntry.data.competition.ClassSetup.EnableMultiClass) {
                let html    = '';
                let options = [];
                let classes = this._getParticipantClasses(participant, false, false); // TODO - Should we include invalid classes?

                const $classesWrapper   = $(element).parents('.row').find('#ddlOtherClasses-wrapper');
                const idTokens          = $classesWrapper.attr('id').split('-');
                const newID             = 'ddlOtherClasses';
                const $select           = $('#' + newID);
                const selected          = $select.length ? $select.val() : [];

                classes && classes.forEach((v) => {
                    var isMain = parseInt(element.value) === v.ID;

                    var isSelected = selected.some((s) => parseInt(s) === v.ID) || (isInit && v.Participate);
                    options.push('<option value="' + v.ID + '"' + (isMain ? ' disabled="disabled"' : '') + (isSelected && !isMain ? ' selected="selected"' : '') + '>' + v.Name + '</option>');
                });

                if (options.length > 1) {
                    html = `<select id="${newID}" name="${newID}" class="custom-select" multiple>` +
                        options.join('') +
                        `</select>`;
                }

                $(element).parents('.row').find('#ddlOtherClasses-wrapper').empty().html(html);

                $('option', '#' + newID).get().forEach((v) => {
                    v.addEventListener('mousedown', (e) => {
                        e.preventDefault();
                        v.parentElement.focus();
                        v.selected = !v.selected;
                        return false;
                    }, false);
                });
            }

            if (this.compEntry.data.competition.Request.TeeWishesOpenFor === 2) {
                this._updateAvailableTees();
            }
        }

        _ddlTeamClassOnChange(element, team) {
            let classID = parseInt(element.value);
            let classes = [];

            classID && this.compEntry.data.requestData.Classes.forEach((v) => {
                if (v.ID === classID) {
                    classes.push(v);
                }
            });

            this._updateTeamClassErrorText(classes);

            if (this.compEntry.data.competition.Request.TeeWishesOpenFor === 2) {
                this._updateAvailableTees();
            }
        }

        _updateTeamClassErrorText(classes) {
            classes && classes.sort(function (a, b) { // Show team classes first
                return b.Type - a.Type;
            });

            const invalidClassHTML = this._getInvalidClassesText(classes, _.translations.Team);
            $('.teams-error-wrapper', this.$wrapper)
                .find('.error-message-main-content')
                .html(invalidClassHTML)
                .end()
                .toggleClass('d-none', invalidClassHTML === '');

            this.compEntry.setAllowNext(invalidClassHTML === '');
        }

        _updateAvailableTees() {
            var that = this;

            this.compEntry.data.requestData.Entries.forEach((v) => {
                var classID = null;
                var $ddlClass = $('#ddlClass');
                var $ddlMainClass = $('#ddlMainClass');

                if ($ddlClass.length) {
                    classID = $ddlClass.val();
                }
                else if ($ddlMainClass.length) {
                    classID = $ddlMainClass.val();
                }

                classID = classID ? parseInt(classID) : classID;
                var availableTees = null;

                $.each(that.compEntry.data.requestData.Classes, function (kC, vC) {
                    var isSelectedClass = classID && classID === vC.ID;
                    if (vC.ExternalID === v.ExternalID && vC.Status !== 4 && (!classID || isSelectedClass)) {
                        if (isSelectedClass) { // Specific class selected, check whether the user can select TeeInHCPCompetitions for this class
                            availableTees = vC.AvailableTees;
                            return false; // Break the vC-loop
                        }
                        else if (!classID) { // No specific class selected, check whether the user can select TeeInHCPCompetitions for any class
                            // Get the type of this class
                            var type = -1;
                            $.each(that.compEntry.data.competition.Classes, function (key, value) {
                                if (value.ID === vC.ID) {
                                    type = value.Type;
                                    return false; // Break the value-loop
                                }
                            });

                            if ((that.compEntry.asTeam && type === 2) || !that.compEntry.asTeam) {
                                availableTees = vC.AvailableTees;
                            }
                        }
                    }

                    if (availableTees) {
                        return false; // Break the vC-loop
                    }
                });

                var $ddlTee = $('#ddlTee_' + v.MemberID);
                var currentValue = $ddlTee.val();
                var $options = $('option', $ddlTee);

                if (currentValue && availableTees && availableTees[currentValue] == undefined) {
                    $ddlTee.val(''); // The selected tee is not available, reset the selection.
                }

                $options.each(function () {
                    if (!this.value)
                        return true; // Skip this element

                    var $this = $(this);
                    var text = $this.attr('data-text');
                    var tee = availableTees ? availableTees[this.value] : undefined;
                    var hideOption = tee == undefined;
                    var isHidden = $this.parent().is('span');

                    $this.toggle(!hideOption).html(text + (tee === 1 ? ' (' + _.translations.Default + ')' : ''));

                    if (!hideOption && isHidden)
                        $this.unwrap();
                    else if (hideOption && !isHidden)
                        $this.wrap('<span>'); // KJ 2023-05-10: For some reason iOS doesn't appear to respect the display: none on options. The internet suggests wrapping the option in a span; Even though it's invalid HTML, it does the trick, so let's go with that for now (we could also disable the option, but for now the goal is to hide it, so let's see if we can make this work).
                });

                var teeIDs = availableTees ? Object.keys(availableTees) : [];
                var disable = teeIDs.length <= 1; 
                $ddlTee.attr('disabled', disable).attr('data-disabled', disable ? 1 : 0); // If only one tee is available, show that one as selected and disable the dropdown (we set data-disabled as well to check for when saving, to make sure we don't save the selection when the user couldn't make a choice).

                if (disable) {
                    $ddlTee.val(teeIDs.length ? teeIDs[0] : null);
                }
            });
        }

        _checkRequestResponse(data) {
            if (!data)
                return null;

            let errorMessages = [];

            if (data.ErrorMessage) {
                errorMessages.push(data.ErrorMessage);
            }
            else if (data.InvalidEntries) {
                data.InvalidEntries.forEach((v) => {
                    let title = null;
                    let msg   = null;

                    switch (v.EntryError) {
                        case 1:
                            title = _.translations.ExistingPlayer;
                            msg   = _.translations.ThisPersonAlreadyExistsInTheCompetition;
                            break;
                        case 2:
                            title = _.translations.InactivePlayer;
                            msg   = _.translations.ThisPersonIsNotActiveInAnyClub;
                            break;
                        case 3:
                            title = _.translations.SuspendedPlayer;
                            msg   = _.translations.ThisPlayerCannotBeAddedPlayerSuspended;
                            break;
                        case 4:
                            title = _.translations.UnknownPlayer;
                            msg   = _.translations.ThePlayerWasNotFound;
                            break;
                    }

                    if (msg)
                        msg = `${title} (${v.GolfID}): ${msg}`;

                    if (msg) {
                        errorMessages.push(msg);
                    }

                });
            }

            if (errorMessages.length) {
                _.ui.errormodal({
                    html  : `<div>${errorMessages.join('<br>')}</div>`,
                    title : _.translations.Error
                });

                return null;
            }

            $('#ddlClass').length === 0 && this._updateTeamClassErrorText(data.Classes); // We only need to do this if the user cannot select a class, otherwise the error will be updated by the onchange on the class dropdown being triggered
            this.compEntry.setAllowAddPlayer(data);

            return data;
        }

        _getInvalidClassesText(classes, title) {
            const invalidClasses = classes.filter((v) => v.Status === 4);
            const that = this;

            var html = [];
            invalidClasses.forEach((v) => {
                v.InvalidCause.forEach((i) => {
                    html.push(`<div>${v.Name} - ${v.Type === 2 ? _.translations.Team : v.ExternalID}: ${that._translateInvalidCause(i, v)}</div>`);
                });
            });

            return html.join('') || '';
        }

        _translateInvalidCause(invalidCause, classObj) {
            var translation = '';

            switch (invalidCause) {
                case 1:
                    translation = _.translations.UnknownCause;
                    break;
                case 2:
                    translation = _.translations.NotCalculated;
                    break;
                case 3:
                    translation = _.translations.ThePlayersHCPIsTooLow;
                    break;
                case 4:
                    translation = _.translations.ThePlayersHCPIsTooHigh;
                    break;
                case 5:
                    translation = _.translations.ThePlayerIsTooYoung;
                    break;
                case 6:
                    translation = _.translations.ThePlayerIsTooOld;
                    break;
                case 7:
                    translation = _.translations.ThePlayersGenderIsNotAllowed;
                    break;
                case 8:
                    translation = _.translations.ThePlayersPlayerStatusIsNotAllowed;
                    break;
                case 9:
                    translation = _.translations.ThereAreNotEnoughTeamMembersOnTheTeam;
                    break;
                case 10:
                    translation = _.translations.ThereAreTooManyTeamMembersOnTheTeam;
                    break;
                case 11:
                    translation = _.translations.TheTotalTeamHCPIsTooLow;
                    break;
                case 12:
                    translation = _.translations.TheTotalTeamHCPIsTooHigh;
                    break;
                case 13:
                    translation = _.translations.BothAManAndAWomanMustBeOnTheTeam;
                    break;
                case 14:
                    translation = _.translations.OneOrMoreTeamMembersAreInvalid;
                    // TODO - Retrieve alternative error text for player like in oMG, something about "this competition requires EGA Handicap, this player does not.."
                    break;
                case 15:
                    translation = _.translations.ThereAreNoTeamMembers;
                    break;
                case 16:
                    translation = _.translations.ThePlayersMembershipIsInvalid;
                    break;
                case 17:
                    var classHcpStatus = classObj.HcpStatus;

                    if (classHcpStatus === 1 || classHcpStatus === 2)
                        translation = _.translations.ThePlayerDoesNotHaveHandicapStatus.replace('%handicapstatus%', classHCPStatus === 1 ? _.translations.HandicapStatusActive : _.translations.HandicapStatusInactive);
                    else
                        translation = _.translations.ThePlayersHCPStatusIsNotAllowed;

                    break;
            }

            return translation;
        }

        validate() {
            if (this.compEntry.asTeam && this.compEntry.data.requestData.Teams && this.compEntry.data.requestData.Teams.length) {
                var teamClasses = this._getParticipantClasses(this.compEntry.data.requestData.Teams[0], true, true);
                var hasValidClass = teamClasses.some((v) => v.Status !== 4);

                if (teamClasses.length > 0 && !hasValidClass) { // If there are any team classes, but the current team doesn't fit in any of them, show an error message
                    this._updateTeamClassErrorText(this.compEntry.data.requestData.Classes);
                    return false;
                }
            }

            return true;
        }

        onBeforeLeave() {
            this.compEntry.data.requestData.Entries.forEach((v) => {
                var hasEditRow = true; // TODO - Editing a signup as individual when you're on a team should show your team members, but only allow you to edit yourself

                if (hasEditRow) {
                    var teeTime = $('#ddlTeeTimeWish').val();
                    var $ddlTee = $('#ddlTee_' + v.MemberID);
                    v.Request.TeeTime = teeTime ? parseInt(teeTime) : null;
                    v.Request.TeeGUID = $ddlTee.attr('data-disabled') !== '1' ? $ddlTee.val() : null;
                    v.Request.UseRule515 = $('#chkTee515_' + v.MemberID).prop('checked') === true;
                }
            });

            this.compEntry.data.requestData.Teams.forEach((v) => {
                var $txtTeamName = $('#txtTeamName');

                if ($txtTeamName.length) {
                    v.Name = $.trim($txtTeamName.val());
                }
            });

            if (this.compEntry.data.requestData.Entries.length > 0) { // KJ 2019-03-03 - This bit is copied from oMG. I don't know what good the Entries.length check did, and if it was a problem that classes are always set regardless of whether the user can select anything. But hopefully it works for now
                var $ddlClass = $('#ddlClass');
                var selectedClass = parseInt($ddlClass.val());
                var primaryClass = parseInt($('#ddlMainClass').val());
                var otherClasses = $('#ddlOtherClasses').val();

                if (this.compEntry.data.competition.ClassSetup.EnableMultiClass) {
                    !isNaN(primaryClass) && this.compEntry.data.requestData.Classes.forEach((v) => { // KJ 2021-08-27 - If a primary class could not be parsed, we don't make any changes to their classes. We just send everything "as is", i.e. how we received it. We assume the GolfBox API will take care of the reset
                        if ((this.compEntry.asTeam && v.Type === 1) || (!this.compEntry.asTeam && v.Type === 2)) {
                            return true; // Skip this
                        }

                        v.IsPrimary = primaryClass === v.ID;
                        v.Participate = v.IsPrimary ? true : otherClasses && otherClasses.some((oc) => parseInt(oc) === v.ID);
                        v.AssignType = 2; // Player
                        v.Status = 0; // Entrant
                    });
                }
                else {
                    var canSelectClass = $ddlClass.length > 0;

                    if (canSelectClass) { // KJ 2019-06-17 - If the user can't select a class, we don't make any changes to their classes. We just send everything "as is", i.e. how we received it. We assume the GolfBox API will take care of the rest
                        this.compEntry.data.requestData.Classes.forEach((v) => {
                            if ((this.compEntry.asTeam && v.Type === 1) || (!this.compEntry.asTeam && v.Type === 2)) {
                                return true; // Skip this
                            }

                            v.IsPrimary = selectedClass === v.ID;
                            v.Participate = v.IsPrimary;
                            v.AssignType = v.IsPrimary ? 2 : 1; // 1: Auto, 2: Player

                            if (v.Status !== 4 || v.Participate) { // If the entry is not invalid in this class, or they have somehow been allowed to select this class anyway, we set the status to Entrant.
                                v.Status = 0; // Entrant
                            }
                        });
                    }
                }

                var warnings = [];
                var warningType = 'info';
                var warningTitle = _.translations.PleaseNote;
                var enableMultiClass = this.compEntry.data.competition && this.compEntry.data.competition.ClassSetup && this.compEntry.data.competition.ClassSetup.EnableMultiClass;
                var includeClassName = enableMultiClass;
                var that = this;

                !this.compEntry.isEdit && this.compEntry.data.competition && this.compEntry.data.competition.Classes && this.compEntry.data.competition.Classes.forEach((v) => {
                    var isSelected = !selectedClass || v.ID === selectedClass;

                    if (enableMultiClass) {
                        isSelected = primaryClass === v.ID || (otherClasses && otherClasses.some((oc) => parseInt(oc) === v.ID));
                    }

                    if (isSelected) {
                        if (v.MaxParticipantsReached && v.ReserveListPrincipleText) {
                            var className = '';

                            if (includeClassName) {
                                that.compEntry.data.requestData && that.compEntry.data.requestData.Classes && that.compEntry.data.requestData.Classes.forEach((vC) => {
                                    if (vC.ID === v.ID) {
                                        className = vC.Name;
                                        return false; // Break the vC-loop
                                    }
                                });
                            }

                            warnings.push((className ? className + ': ' : '') + _.translations.SignupInTheClassIsPossibleButMaxParticipantsHasBeenReached.replace('%ReservelistPrinciple%', v.ReserveListPrincipleText));
                            warningType = 'confirm';
                            warningTitle = _.translations.MaximumParticipantsReached;
                        }

                        return false; // Break the v-loop
                    }
                });

                this.compEntry.data.requestData.Entries.forEach((v) => {
                    !v.ID && v.HandicapStatus === 1 && this.compEntry.data.requestData.Classes.forEach((vC) => { // If the player isn't signed up yet, run through all their classes to check their HCP Status compatibility (HCP Status 1 means Inactive)
                        var participate = vC.Participate ||
                            (this.compEntry.asTeam && this.compEntry.data.competition.Classes.filter((o) => o.Type === 2).length === 1) || // Special case for team signups when there is only one team class. In this case, it seems the class isn't marked with Participate
                            (!this.compEntry.asTeam && this.compEntry.data.competition.Classes.length === 1); // Special case for individual signup in team competitions. In these, it seems the class isn't marked with Participate. We're comparing with the total number of classes, and not just team classes, as if there was a combination of the two, you would be able to choose, which would cause one of them to have Participate set, and we don't want any false positives

                        if (((!this.compEntry.asTeam && vC.ExternalID === v.ExternalID) || (this.compEntry.asTeam && !vC.ExternalID)) && participate) {
                            var currentClass = this.compEntry.data.competition.Classes && this.compEntry.data.competition.Classes.find((o) => o.ID === vC.ID);

                            if (currentClass && currentClass.HCPStatus === 0 && currentClass.ExcludeInactiveHCPFromResult) {
                                var prefix = '';

                                if (this.compEntry.data.competition.ClassSetup.EnableMultiClass)
                                    prefix = vC.Name;
                                else if (this.compEntry.asTeam)
                                    prefix = v.ExternalID;

                                var party = this.compEntry.asTeam ? _.translations.ThePlayer : _.translations.You; // In a team signup we just say 'The player' instead of 'You', regardless of what player has the problem
                                var doesntHave = this.compEntry.asTeam ? _.translations.DoesNotHave : _.translations.DoNotHave; // Should match the party above
                                var themselves = this.compEntry.asTeam ? _.translations.Themselves : _.translations.Yourself;
                                warnings.push((prefix ? prefix + ': ' : '') + _.translations.PartyDoesntHaveHCPStatusPartyCanParticipateButWillNotBeOnTheList.replace(/%Party%/g, party).replace(/%party%/g, party.toLowerCase()).replace('%doesNotHave%', doesntHave.toLowerCase()).replace('%themselves%', themselves.toLowerCase()).replace('%handicapstatus%', _.translations.HandicapStatusActive + ' (' + _.translations.HandicapStatusActive_Short + ')') + '.');
                            }
                        }
                    });
                });

                if (warnings.length > 0) {
                    var hideButtonOK = false;
                    var continueOnClose = true;
                    var useOKCancel = false;

                    var continueFunc = function () {
                        that.compEntry.next(true);
                    };

                    if (warningType === 'confirm') {
                        hideButtonOK = true;
                        continueOnClose = false;
                        useOKCancel = true;
                    }

                    _.ui[warningType + 'modal']({
                        html: '<div>' + warnings.join('</div><div>') + '</div>', title: warningTitle, className: 'competition-entry-warning-modal', hideButtonOK: hideButtonOK, onClose: continueOnClose ? continueFunc : undefined, btnYesOnClick: !continueOnClose ? continueFunc : undefined, useOKCancel: useOKCancel
                    });

                    return false; // Return false to indicate that the user needs to confirm something before we can continue
                }
            }
        }
    }

    class _ViewQuestions {
        constructor(compEntry) {
            abstractView(this, compEntry);

            this.$wrapper = $('#comp-entry-view-questions', this.compEntry.$target);
        }

        render() {
            this.renderPlayersSummary();

            const renderRow = (content, participantID) => {
                return '<div class="request">' + content.replace(/{PARTICIPANT}/g, participantID) + '</div>';
            };

            const setValueRdo = ($tmp, value) => {
                $tmp.find('input[type="radio"][value="' + value + '"]').attr('checked', true);
            };

            const setValueTxt = ($tmp, value) => {
                $tmp.find('input').attr('value', value || '');
            };

            const setValueQuestion = ($tmp, participantQuestions, question) => {
                var participantQuestion = participantQuestions.find((v) => v.Info && v.Info.ID === question.ID);
                var answer = participantQuestion && participantQuestion.Answer ? participantQuestion.Answer.Answer : undefined;

                if (answer !== undefined && answer !== null) {
                    switch (question.QuestionType) {
                        case 1: // YesNo
                            setValueRdo($tmp, answer === true ? 1 : 0);
                            break;
                        case 2: // Text
                            setValueTxt($tmp, answer);
                            break;
                        case 3: // Date
                            setValueTxt($tmp, moment(_.cc.textToDateTime(answer)).format('YYYY-MM-DD'));
                            break;
                        case 4: // Time
                            let date = _.cc.textToDateTime(answer);
                            setValueTxt($tmp, date.getHours() + '' + date.getMinutes());
                            break;
                        case 5: // Number
                            setValueTxt($tmp, answer);
                            break;
                        case 6: // List
                            $tmp.find('select > option[value="' + answer + '"]').attr('selected', true);
                            break;
                        case 7: // AcceptRequired
                            $tmp.find('input[type="checkbox"]').attr('checked', true);
                            break;
                    }
                }
            };

            const renderRequestsPlayer = (player) => {
                const $templateGolfCart = $('#rt-rdo-golfcart');
                const $templateCaddie = $('#rt-rdo-caddie');
                const requests = [];

                const renderPlayerRow = function($tmp) {
                    requests.push(renderRow($tmp.html(), player.MemberID));
                };

                if ($templateGolfCart.length) {
                    const $tmp = $templateGolfCart.clone();

                    if (player.ID && player.Request) {
                        setValueRdo($tmp, player.Request.GolfCart ? 1 : 0);
                    }

                    renderPlayerRow($tmp);
                }

                if ($templateCaddie.length) {
                    const $tmp = $templateCaddie.clone();

                    if (player.ID && player.Request) {
                        setValueRdo($tmp, player.Request.Caddie ? 1 : 0);
                    }

                    renderPlayerRow($tmp);
                }

                this.compEntry.data.competition.Questions && this.compEntry.data.competition.Questions.forEach((v) => {
                    if (!v.IsTeamQuestion) {
                        const $questionTemplate = $('#qt-' + v.ID);

                        if ($questionTemplate.length) {
                            const $tmp = $questionTemplate.clone();

                            setValueQuestion($tmp, player.Questions, v);

                            renderPlayerRow($tmp);
                        }
                    }
                });

                if (!this.compEntry.asTeam && this.compEntry.data.competition.Request && this.compEntry.data.competition.Request.AllowPlayersNote) {
                    requests.push(this._getNoteHTML(player.Note));
                }

                if (requests.length) {
                    this.compEntry.asTeam && requests.splice(0, 0, '<div class="request-header">' + player.FirstName + ' ' + player.LastName + '</div>');
                    $('.requests-list', this.$wrapper).append(requests.join(''));
                }
            };

            const renderRequestsTeam = (team, entries) => {
                const requests = ['<div class="request-header">' + _.translations.Team + '</div>'];

                const renderTeamRow = function ($tmp) {
                    requests.push(renderRow($tmp.html(), 'team'));
                };

                this.compEntry.data.competition.Questions && this.compEntry.data.competition.Questions.forEach((v) => {
                    if (v.IsTeamQuestion) {
                        const $questionTemplate = $('#qt-' + v.ID);

                        if ($questionTemplate.length) {
                            const $tmp = $questionTemplate.clone();

                            setValueQuestion($tmp, team.Questions, v);

                            renderTeamRow($tmp);
                        }
                    }
                });

                if (this.compEntry.data.competition.Request && this.compEntry.data.competition.Request.AllowPlayersNote) {
                    requests.push(this._getNoteHTML(entries && entries.length ? entries[0].Note : ''));
                }

                requests.length && $('.requests-list', this.$wrapper).append(requests.join(''));
            };

            $('.requests-list', this.$wrapper).empty();

            if (this.compEntry.asTeam) {
                this.compEntry.data.requestData.Entries.forEach((v) => {
                    renderRequestsPlayer(v);
                });

                renderRequestsTeam(this.compEntry.data.requestData.Teams[0], this.compEntry.data.requestData.Entries);
            } else {
                this.compEntry.data.requestData.Entries.forEach((v) => {
                    renderRequestsPlayer(v);
                });
            }

            var $requests = $('.requests-list', this.$wrapper);
            var that = this;

            var onAnswerChange = function () {
                that.compEntry.updateNextText();
            };

            $('input[type="radio"], input[type="checkbox"]', $requests).on('click', onAnswerChange);
            $('select', $requests).on('change', onAnswerChange);
            onAnswerChange(); // Make sure to set the proper state

            var $dateElements = $('.icon-calendar', $requests);

            $dateElements.length && $.each($dateElements, function (k, v) {
                var $parent = $(v).parents('.input-group');

                flatpickr('#' + $parent.attr('id'), {
                    wrap       : true,
                    dateFormat : 'Y-m-d'
                });
            });

            var $selectElements = $('.custom-select', $requests);

            $selectElements.length && $.each($selectElements, function (k, v) {
                $(v).trigger('change');
            });

            var $timeElements = $('.input-time', $requests);

            $timeElements.length && $.each($timeElements, function (k, v) {
                _.ui.time('#' + $(v).attr('id'));
            });

            // starting validation register
            const fvFields = this.compEntry.validation.fv.getFields();

            Object.keys(fvFields)
                .filter((v) => v.indexOf('{PARTICIPANT}') !== -1)
                .forEach((v) => {
                    this.compEntry.validation.fv.removeField(v);
                });

            const requestsFvFields = $('[name]', $requests)
                .filter((i, e) => Object.keys(e.dataset).some((v) => v.startsWith('fv')))
                .get();

            requestsFvFields
                .forEach((v) => {
                    this.compEntry.validation.fv.addField(
                        v.name,
                        this.compEntry.validation.fv.plugins.declarative.parseElement(v)
                    );
                });
        }

        renderPlayersSummary() {
            let html;

            if (this.compEntry.asTeam) {
                html = `<div class="row">` +
                    this.compEntry.data.requestData.Entries.map((v) => `<div class="col-auto">${v.FirstName} ${v.LastName} ${v.FormattedHCP}</div>`).join('') +
                `</div>`;
            } else {
                const player = this.compEntry.data.requestData.Entries[0];

                html = `<div class="row">` +
                    `<div class="col-6 col-md-3">${player.FirstName} ${player.LastName}</div>` +
                    `<div class="col-6 col-md-3">${player.MemberID}</div>` +
                    `<div class="col-6 col-md-3">${player.FormattedHCP}</div>` +
                    `<div class="col-6 col-md-3">${player.ClubName}</div>` +
                `</div>`;
            }

            $('.players-summary', this.compEntry.$target).html(html).removeClass('hide');
        }

        _getNoteHTML(value) {
            return [
                '<div class="note-wrapper">',
                    '<div class="note-header">' + _.translations.MessageForTheClubOrCompetitionLeader + '</div>',
                    '<div class="row">',
                        '<div class="col-12 col-lg-7">',
                            '<textarea id="txtNote" class="form-control" rows="3">' + (value || '') + '</textarea>', // Same ID for both entries and team as the value is stored on Entries
                        '</div>',
                    '</div>',
                '</div>'
            ].join('');
        }

        _getQuestionAnswer(questionID, typeOfQuestion, identifier) {
            if (questionID) {
                var value = null;

                const getSelector = (prefix) => {
                    return '#' + prefix + '-question-' + questionID + '-' + identifier;
                };

                const getElement = (prefix) => {
                    return $(getSelector(prefix));
                };

                switch (typeOfQuestion) {
                    case 1: // YesNo
                        value = $('[id^="rdo-question-' + questionID + '-' + identifier + '"]:checked').val();
                        return value !== undefined && value !== null ? value === '1' : value;
                    case 2: // FreeText
                        return getElement('txt').val();
                    case 3: // Date
                        var el = document.querySelector(getSelector('txt')); // For some reason we can only retrieve the ._flatpickr instance with document.querySelector
                        var fp = el ? el.parentElement._flatpickr : null;

                        if (fp && fp.selectedDates && fp.selectedDates.length) {
                            return _.cc.dateTimeToText(fp.selectedDates[0]); // TODO - Is this how we want it done?
                        }

                        return null;
                    case 4: // Time
                        value = getElement('txt').val();

                        if (value !== undefined && value !== null && value !== '') {
                            var time = new Date();
                            var hours = value.substr(0, 2);
                            var minutes = value.substr(3, 5);

                            time.setHours(hours);
                            time.setMinutes(minutes);
                            time.setSeconds(0);

                            return _.cc.dateTimeToText(time); // TODO - Is this how we want it done?
                        }

                        return value;
                    case 5: // Number
                        value = getElement('txt').val();
                        return value !== undefined && value !== null && value !== '' ? parseInt(value) : null;
                    case 6: // List
                        value = getElement('ddl').val();
                        return value ? parseInt(value) : value;
                    case 7: // AcceptRequired
                        return getElement('chk').prop('checked');
                }

                return value;
            }

            return null;
        }

        _getProduct(question, answer, participantIdentifier) {
            var product = null;
            var productID = question.Info.ProductID;
            var price = question.Info.Price;
            var currency = question.Info.Currency;
            var vat = question.Info.VAT;

            if (!price && question.Info.TypeOf === 6) { // List question, find the selected option and retrieve its price (if any)
                var option = $('option[value="' + answer + '"]', $('#ddl-question-' + question.Info.ID + '-' + participantIdentifier));
                var priceTokens = (option.attr('data-price') || '').split(';');
                productID = parseInt(option.attr('data-productid'));

                // TODO - productID may be incorrect on edit if a product for this question has already been added with a different option selected as answer

                if (priceTokens && priceTokens.length > 1) {
                    price = parseInt(priceTokens[0]);
                    currency = _.currencies.getGBTourCurrency(priceTokens[1], true).Value;
                }

                vat = 6; // TODO - Parse VAT
            }

            if (price && price > 0) {
                product = {
                    ID: productID,
                    Name: question.Info.ProductName,
                    Type: 3, // Question
                    Currency: currency,
                    Price: price,
                    VAT: vat,
                    Paid: 0,
                    Balance: price * -1,
                    IsPaid: false,
                    AccountNumber: question.Info.AccountNumber,
                    CostCenter: question.Info.CostCenter
                };
            }

            return product;
        }

        onBeforeLeave() {
            var that = this;

            // TODO - Remove products we have added for questions that have had their answer changed

            const handleQuestions = (v, participantIdentifier) => {
                if (v.Questions && v.Questions.length) {
                    // Step 1: Create a list of products from the current questions
                    var currentProducts = [];

                    v.Questions.forEach((vQ) => {
                        var answer = that._getQuestionAnswer(vQ.Info.ID, vQ.Info.TypeOf, participantIdentifier);
                        vQ.Answer.Answer = answer !== undefined && answer !== null && answer !== '' ? answer : null;

                        if (answer) {
                            var product = that._getProduct(vQ, answer, participantIdentifier);

                            if (product && product.ID) {
                                currentProducts.push(product);
                            }
                        }
                    });

                    // Step 2: Add any new products. TODO - Do we change the product details for List questions?
                    currentProducts.forEach((cP) => {
                        var productFound = false;

                        v.Products && $.each(v.Products, function (k, vP) { // Using a $.each here as the .forEach does not allow us to continue or break the loop
                            if (vP.Type !== 3)
                                return true; // Skip the element, we only want to look at Question-related products

                            if (vP.ID === cP.ID) {
                                productFound = true;
                            }

                            if (that.compEntry.isEdit) {
                                // TODO - Do any List questions point to this product?
                            }

                            if (productFound)
                                return false; // Break the vP-loop
                        });

                        if (!productFound) {
                            v.Products.push(cP);
                        }
                    });

                    // Step 3 - Remove any questions no longer having any products. TODO - Do we want to remove a product that has already been paid?
                    for (var i = 0; i < v.Products.length; i++) {
                        var vP = v.Products[i];

                        if (vP.Type === 3 && !vP.IsPaid && !currentProducts.some((cP) => cP.ID === vP.ID)) {
                            v.Products.splice(i, 1); // Remove 1 elements at index i
                            i--; // Go one back to make sure we're not accidentally skipping any elemnts
                        }
                    }
                }
            };

            this.compEntry.data.requestData.Entries.forEach((v) => {
                var hasEditRow = true; // TODO - Editing a signup as individual when you're on a team should show your team members, but only allow you to edit yourself

                if (hasEditRow) {
                    v.Note = $.trim($('#txtNote').val());
                    v.Request.GolfCart = $('[id^="rdo-golfcart-' + v.MemberID + '"]:checked').val() === '1';
                    v.Request.Caddie = $('[id^="rdo-caddie-' + v.MemberID + '"]:checked').val() === '1';

                    handleQuestions(v, v.MemberID);
                }
            });

            this.compEntry.data.requestData.Teams.forEach((v) => {
                var $txtTeamName = $('#txtTeamName');

                if ($txtTeamName.length) {
                    v.Name = $.trim($txtTeamName.val());
                }

                handleQuestions(v, 'team');
            });
        }

        validateAcceptRequired(input) {
            return input.element.checked;
        }
    }

    class _ViewPayments {
        constructor(compEntry) {
            abstractView(this, compEntry);
        }

        render() {
            var paymentRows = [];

            const renderRow = (text, price, payNow = '') => {
                return [
                    '<div class="row">',
                        '<div class="col-6 col-lg-5">' + text + '</div>',
                        '<div class="col-6 col-lg-2 text-right">' + price + '</div>',
                        '<div class="col-12 col-lg text-lg-right">' + payNow + '</div>',
                    '</div>'
                ].join('');
            };

            const renderProducts = (participant, participantIdentifier) => {
                let that = this;
                let products = participant.Products;
                let paymentAllowed = this.compEntry.data.competition.OnlineEntryAndPayment;
                let paymentRequired = false;
                var oep = this.compEntry.data.competition.OnlineEntryAndPayment;

                if (oep) {
                    paymentAllowed = oep.EnableOnlinePayment && oep.PaymentWindowOpen;
                    paymentRequired = oep.PaymentRequired;

                    if (oep.PaymentRequired && !oep.PaymentWindowOpen) { // KJ 2019-05-02 - This is a special exception that addresses a setup combination we consider invalid. Payment is required, but the payment window is not open yet. The user would either be unable to continue, or they would be able to pay even though they aren't supposed to yet. In this specific exception, we disregard the payment part and let users sign up without payment. (When we decide to remove this exception we may want to disable the payment button under these circumstances)
                        paymentAllowed = false;
                        paymentRequired = false;
                    }
                }

                const renderPayNow = (product, participantIdentifier) => {
                    const id = 'chkProductPayNow_' + product.ID + '_' + participantIdentifier;
                    const checked = $('#' + id).prop('checked');
                    const paid = product.IsPaid; // TODO - What do we do when an item is already paid?

                    return [
                        '<div class="custom-control custom-checkbox ' + (!paymentAllowed ? 'invisible' : '') + '">',
                            '<input type="checkbox" id="' + id + '" name="chkProductPayNow" class="custom-control-input"' + (product.Price ? ' data-price="' + product.Price + '"' : '') + (product.Currency ? ' data-currency="' + product.Currency + '"' : '') + (!paymentAllowed || paymentRequired || paid ? ' disabled="disabled"' : '') + (paymentRequired || paid || checked ? ' checked="checked"' : '') + (paid ? ' data-fulfilled="1"' : '') + ' />',
                            '<label class="custom-control-label" for="' + id + '">' + (paid ? _.translations.Paid : _.translations.PayNow) + '</label>',
                        '</div>'
                    ].join('');
                };

                products.sort(function (a, b) {
                    return a.Type - b.Type;
                });

                products && products.forEach((v) => {
                    var text = v.Type === 1 ? _.translations.EntryFee : v.Type === 2 ? _.translations.CompetitionGreenFee : v.Name;

                    if (v.Type === 3 && participant.Questions && that.compEntry.data.competition.Questions) {
                        $.each(participant.Questions, function (kQ, vQ) {
                            var matches = false;

                            if (vQ.Info.ProductID === v.ID) {
                                matches = true;
                            }
                            else if (vQ.Info.TypeOf === 6) {
                                var question = null;

                                $.each(that.compEntry.data.competition.Questions, function (kCQ, vCQ) {
                                    if (vCQ.ID === vQ.Info.ID) {
                                        question = vCQ;
                                        return false; // Break the vCQ-loop
                                    }
                                });

                                if (question && question.Options) {
                                    $.each(question.Options, function (kO, vO) {
                                        if (vO.ProductID === v.ID) {
                                            matches = true;
                                            return false; // Break the vO-loop
                                        }
                                    });
                                }
                            }

                            if (matches) {
                                text = vQ.Info.ProductName;
                                return false; // Break the vQ-loop
                            }
                        });
                    }

                    var rows = [];

                    var renderProduct = function (product) {
                        rows.push(renderRow(text, product.Price ? _.cc.formatAmount(product.Price, true) + ' ' + _.currencies.getGBTourCurrency(product.Currency).Text : '', renderPayNow(product, participantIdentifier)));
                    };

                    if (v.Paid > 0 && v.Paid !== v.Price) { // The user has made a payment for this product, but the price of the product has since been changed. Add a row for the original amount, and a row for the remaining amount
                        var orgProduct = $.extend(true, {}, v);
                        orgProduct.ID += '_original';
                        orgProduct.Price = orgProduct.Paid;
                        orgProduct.Balance = 0;
                        orgProduct.IsPaid = true;

                        renderProduct(orgProduct);

                        var newProduct = $.extend(true, {}, v);
                        newProduct.Price -= newProduct.Paid;
                        newProduct.Paid = 0;
                        newProduct.IsPaid = newProduct.Price < 0; // This will mostly be false, but in those rare cases where the user has paid more than the current price of the product, we need to mark this as paid

                        renderProduct(newProduct);
                    }
                    else
                        renderProduct(v);

                    paymentRows.push('<div class="payment">' + rows.join('') + '</div>');
                });
            };

            if (this.compEntry.asTeam) {
                this.compEntry.data.requestData.Entries.forEach((v) => {
                    paymentRows.push('<div class="payment-header">' + v.FirstName + ' ' + v.LastName + '</div>');
                    renderProducts(v, v.MemberID);
                });

                paymentRows.push('<div class="payment-header">' + _.translations.Team + '</div>');
                renderProducts(this.compEntry.data.requestData.Teams[0], 'team');
            } else {
                this.compEntry.data.requestData.Entries.forEach((v) => {
                    renderProducts(v, v.MemberID);
                });
            }

            var sumRows = [];
            sumRows.push(renderRow(_.translations.Sum, '<div class="lblSum"></div>'));
            sumRows.push(renderRow(_.translations.PayNow, '<div class="lblPayNow"></div>'));
            this.compEntry.isEdit && sumRows.push(renderRow(_.translations.AlreadyPaid, '<div class="lblAlreadyPaid"></div>'));
            sumRows.push(renderRow(_.translations.StillToPay, '<div class="lblStillToPay"></div>'));

            var $paymentsList = $('.payments-list');
            var that = this;

            $paymentsList.html(paymentRows.join(''));
            $('.payment-summaries').html(sumRows.join(''));

            $('input[type="checkbox"]', $paymentsList).off('change').on('change', function () {
                that.updateSums();
                that.compEntry.updateNextText();

                if (that.compEntry.isPaymentOnly) {
                    that.compEntry.setAllowNext(that.getPayNowProducts().length > 0);
                }
            }).eq(0).trigger('change'); // Trigger change on the first one to set the proper state
        }

        getPayNowProducts() {
            return $('[id^="chkProductPayNow_"]:checked:not([data-fulfilled="1"])');
        }

        getSums() {
            var res = {
                total: 0,
                payNow: 0,
                alreadyPaid: 0,
                stillToPay: 0,
                currency: null
            };

            $('input[type="checkbox"]', $('.payments-list')).each(function (k, v) {
                var $v = $(v);
                var price = $v.attr('data-price');
                var currency = $v.attr('data-currency');

                if (price) {
                    price = parseFloat(price); // TODO - Decimals?
                    currency = parseInt(currency);

                    res.total += price;
                    var addToStillToPay = price < 0; // Negative amounts are not added to alreadyPaid or payNow, only to stillToPay, as rows with negative amounts should only be used if the user has paid too much

                    if (!addToStillToPay) {
                        if ($v.attr('data-fulfilled') === '1')
                            res.alreadyPaid += price;
                        else if ($v.prop('checked'))
                            res.payNow += price;
                        else
                            addToStillToPay = true;
                    }

                    if (addToStillToPay)
                        res.stillToPay += price;

                    if (res.currency === null && currency) {
                        res.currency = currency; // We just use the first currency we find. We assume it cannot vary within the same competition
                    }
                }
            });

            return res;
        }

        updateSums() {
            var $summaries = $('.payment-summaries');

            const setSum = (selector, sum, currency) => {
                $(selector, $summaries).html(_.cc.formatAmount(sum, true) + ' ' + _.currencies.getGBTourCurrency(currency).Text);
            };

            var sums = this.getSums();
            var currency = 1;

            setSum('.lblSum', sums.total, currency);
            setSum('.lblPayNow', sums.payNow, currency);
            setSum('.lblAlreadyPaid', sums.alreadyPaid, currency);
            setSum('.lblStillToPay', sums.stillToPay, currency);
        }
    }

    class _ViewFinish {
        constructor(compEntry) {
            abstractView(this, compEntry);

            this.$wrapper = $('#comp-entry-view-finish', this.compEntry.$target);
        }

        render() {
            this.compEntry.$target.empty().html(this.$wrapper.html()).addClass('finish');
        }
    }

    class _ViewSelectTeeTime {
        constructor(compEntry) {
            abstractView(this, compEntry);
            this.$wrapper = $('#comp-entry-view-selectTeeTime', this.compEntry.$target);
            compEntry.data.requestData.SelectTeeTime = null;
            this.spinner = null;
            this.ignore_selected_match_saved_entries = false;
            this.initially_selected_match = null;
            this.ErrorCodeModulePrefix = "003";
            this.force_allow_progression_without_match_selection = false;
            this.saved_entries_part_of_team = false;
            this.saved_entries_not_all_on_same_match = false;
            this.is_editing = false;
        }

        render() {
            const that = this;
            let html = '';
            this.allow_progression_without_match_selection = false;
            this.found_open_slots = false;
            if (this.compEntry.playersCanSelectTeeTime) {
                let $startlists_wrapper = $('#comp-entry-view-selectTeeTime-matches', this.$wrapper);
                if (this.compEntry.data.startlists) {
                    if ('Error' in this.compEntry.data.startlists) {
                        html = that.renderInlineMessage(this.compEntry.data.startlists.Error, 'error');
                        this.allow_progression_without_match_selection = false; 
                    } else {
                        that.initEdit_ifRelevant(that.compEntry.asTeam, that);
                        if ((!('Warning' in this.compEntry.data.startlists)) && that.foundNoCompatibleStartlist(this.compEntry.data.startlists, this.compEntry.asTeam)) {
                            let include_link_in_warning_to_switch_signup_method =  (this.compEntry.data.competition.OnlineEntryAndPayment?.OnlineEntryMethod == 3) && this.compEntry.data.startlists.length > 0;     
                            this.compEntry.data.startlists.Warning = this.renderWarning_noMatchSelectionPossible(this.compEntry.asTeam, include_link_in_warning_to_switch_signup_method, mg.pages.competition.entry.data.requestData.ID, this.is_editing, that);
                            this.force_allow_progression_without_match_selection = include_link_in_warning_to_switch_signup_method;
                        }
                        
                        this.force_allow_progression_without_match_selection = this.force_allow_progression_without_match_selection || this.is_editing;
                        this.allow_progression_without_match_selection = this.force_allow_progression_without_match_selection;
                        if ('Warning' in this.compEntry.data.startlists) {
                            html = that.renderInlineMessage(this.compEntry.data.startlists.Warning, 'warning'); //Please notice, that warnings also block the startlist from being rendered and no tee time can be selected (for now).
                        } else if (this.compEntry.data.startlists.length > 0) {
                            let multiple_start_dates = that.hasMultipleMatchStartDates(this.compEntry.data.startlists);
                            html = (this.compEntry.data.startlists.reduce((html, startlist) => {
                                html += that.renderStartList(startlist, false, multiple_start_dates, that);
                                return html;
                            }, ''));
                        }
                    }
                }
                $startlists_wrapper.html(html);
                this.updateNextBtn(this);
            }
        }

        renderStartList(startList, disabled, multiple_start_dates, that) {
            if (startList && startList.StartList_Reference_ID && startList.StartList_Reference_ID > 0 && 'Matches' in startList && startList.Matches && startList.Matches.length > 0) {
                let not_available = (startList.GroupSizeType == 'Team' && !that.compEntry.asTeam) || (startList.GroupSizeType == 'Player' && that.compEntry.asTeam); 
                if (not_available) {
                    disabled = true;
                }
                startList.Matches.sort((a, b) => {
                    return a != null && b != null && 'Match_Order' in a && 'Match_Order' in b ? a.Match_Order - b.Match_Order : 0;
                })
                let has_match_selection = that.hasMatchSelection(that);
                let selectedMatch = that.getSelectedMatch();
                let show_start_hole_number = ('StartList_Type' in startList && startList.StartList_Type ==2); //shotgun
                return `<div class="comp-entry-startlist">
                    ${  startList.Matches.reduce((html,match) => {html+=that.renderMatch(match, startList, disabled, not_available, has_match_selection, (has_match_selection && selectedMatch?.MatchRID===match.Match_RID), show_start_hole_number, multiple_start_dates, that);return html;},'')  }
                </div>`;
            }
            return '';
        }

        hasMatchSelection(that) {
            let selectedMatch = that.getSelectedMatch();
            return selectedMatch != null && 'MatchRID' in selectedMatch && selectedMatch.MatchRID > 0;
        }

        getSelectedMatch() {
            let that = mg.pages.competition.entry.views.selectTeeTime;
            return that.compEntry.data.requestData.SelectTeeTime;
        }
        setSelectedMatch(obj) {
            let that = mg.pages.competition.entry.views.selectTeeTime;
            that.compEntry.data.requestData.SelectTeeTime = obj;
        }

        resetSelectedMatch() {
            let that = mg.pages.competition.entry.views.selectTeeTime;
            that.setSelectedMatch(null);
        }

        renderMatch(match, startlist, disabled, not_available, has_match_selection, is_selected, show_start_hole_number, multiple_start_dates, that) {
            if (startlist && match && match.Match_RID && match.Match_RID > 0) {
                const groupSize = startlist.GroupSize;

                //Prepare slots
                let slot_startlist_entries = that.prepareSlotEntries(match, startlist, groupSize);
                let number_of_entries = slot_startlist_entries.length;
                while (slot_startlist_entries.length < groupSize) {
                    slot_startlist_entries.push({});
                }

                //Prepare slots locked / open status
                let slot_open_arr = new Array(groupSize);
                let number_of_locked_slots = match.Match_Locked_Slots;
                number_of_locked_slots = 'TryLockFoundOpenSlot' in match && match.TryLockFoundOpenSlot && number_of_locked_slots > 0 && number_of_locked_slots + number_of_entries == groupSize ? number_of_locked_slots - 1 : number_of_locked_slots; //Overrule number of locked slots in case try lock slot succeeded for match.
                let match_initially_selected = that.initially_selected_match != null && that.initially_selected_match.MatchRID == match.Match_RID;

                for (let slotNo = 0; slotNo < groupSize; slotNo++) {
                    slot_open_arr[slotNo] = !startlist.StartList_Locked && !match.Match_Locked && (slotNo + 1 > (number_of_locked_slots + number_of_entries));
                }
                let all_slots_not_open = slot_open_arr.reduce((found_only_locked_slots, slot_open) => found_only_locked_slots && !slot_open, !match_initially_selected);
                let influenced_by_locks = all_slots_not_open && number_of_entries < groupSize;
                that.found_open_slots = that.found_open_slots || number_of_entries < groupSize

                //Handling player/team slotNo ( including the case if player / team currently has entry/entries on match)
                let render_player_prev_slot_as_abandoned = false;
                let player_self_slotNo = -1;
                if (match_initially_selected) {
                    player_self_slotNo = that.findPlayerSlot_initiallySelectedMatch(startlist, slot_startlist_entries, that);
                    render_player_prev_slot_as_abandoned = that.ignore_selected_match_saved_entries;
                } else {
                    player_self_slotNo = is_selected ? slot_open_arr.reduce((first_open_slotNo, slot_open, slotNo) => {
                        return first_open_slotNo == -1 && slot_open ? slotNo : first_open_slotNo
                    }, -1) : -1;
                }

                //Disable btns if relevant
                let render_add_btn_as_disabled = disabled || not_available || all_slots_not_open || has_match_selection;
                let disable_add_btn = disabled || has_match_selection || not_available || (all_slots_not_open && !influenced_by_locks);


                return `<div data-matchrid='${match.Match_RID}' class="comp-entry-startlist-match">
                        <div class="comp-entry-startlist-match-inner">
                            ${(!is_selected ? that.renderBtn_AddMyself(startlist, match, disable_add_btn ,render_add_btn_as_disabled ,that):'')}
                            ${(is_selected ? that.renderBtn_RemoveMyself(startlist, match, disabled, that):'')}
                            ${(show_start_hole_number? `
                                <span class="comp-entry-startlist-match-hole-txt">
                                    ${that.renderHoleTxt(match,disabled,that)}
                                </span>`:'')}
                            <span class="comp-entry-startlist-match-time-txt">
                                ${that.renderMatchStartTimeTxt(match, multiple_start_dates, that) }
                            </span>
                        </div>
                            <ul class='comp-entry-startlist-match-slots'>
                                ${ slot_startlist_entries.reduce((html,startlist_entry,slotNo)=>{ html+=that.renderMatchSlot(match, startlist, startlist_entry,  disabled, slot_open_arr[slotNo] ,not_available, slotNo==player_self_slotNo, render_player_prev_slot_as_abandoned,  that);return html;},'') }
                            </ul>
                    </div>`;
            }
            return '';
        }

        prepareSlotEntries(match, startlist, groupSize) {
            let slot_startlist_entries = new Array(0);
            if (startlist.GroupSizeType == 'Player') {
                slot_startlist_entries = 'Entries' in match ? match.Entries.filter(entry => 'Entry_Reference_ID' in entry && entry.Entry_Reference_ID > 0) : new Array(0)
            }
            if (startlist.GroupSizeType == 'Team') {
                let entries_team_rids_set = new Set();
                slot_startlist_entries = 'Entries' in match ? match.Entries.filter(entry => {
                    if ('Entry_TeamRID' in entry && entry.Entry_TeamRID > 0 && !entries_team_rids_set.has(entry.Entry_TeamRID) && entries_team_rids_set.size < groupSize) {
                        entries_team_rids_set.add(entry.Entry_TeamRID);
                        return true;
                    } else {
                        return false;
                    }
                }) : new Array(0)
            }
            slot_startlist_entries.sort((a, b) => {
                return a != null && 'Entry_Order' in a && b != null && 'Entry_Order' in b ? a.Entry_Order - b.Entry_Order : 0
            });
            return slot_startlist_entries;
        }

        findPlayerSlot_initiallySelectedMatch(startlist, slot_startlist_entries, that) {
            let player_self_slotNo = -1;
            if (startlist.GroupSizeType == 'Team') {
                slot_startlist_entries.forEach((e, index) => {
                    if ('EntryTeamRID' in that.initially_selected_match && that.initially_selected_match.EntryTeamRID == e.Entry_TeamRID) {
                        player_self_slotNo = index;
                    }
                });
            } else {
                slot_startlist_entries.forEach((e, index) => {
                    if ('EntryRID' in that.initially_selected_match && that.initially_selected_match.EntryRID == e.Entry_Reference_ID) {
                        player_self_slotNo = index;
                    }
                });
            }
            return player_self_slotNo;
        }

        renderMatchSlot(match, startlist, startlist_entry, disabled, slot_open, not_available, player_self_slotNo, render_player_prev_slot_as_abandoned, that) {
            let default_entry_txt = (startlist_entry != null && !$.isEmptyObject(startlist_entry) && (('Entry_Reference_ID' in startlist_entry && startlist_entry.Entry_Reference_ID > 0) || ('Entry_TeamRID' in startlist_entry && startlist_entry.Entry_TeamRID > 0)) ? `${mg.translations.Occupied}` : (not_available ? `${mg.translations.NA}` : (!slot_open ? `${mg.translations.Locked}` : `${mg.translations.Unoccupied}`)));
            return `<li class="comp-entry-startlist-match-slot" ${player_self_slotNo && render_player_prev_slot_as_abandoned?'data-abandoned-slot="1"':''}>
                ${that.renderEntryTxt(startlist_entry,  startlist, default_entry_txt, player_self_slotNo, that.compEntry.asTeam, that)}
            </li>`;
        }

        renderEntryTxt(startlist_entry, startlist, default_txt, player_self_slotNo, asTeam, that) {
            let txtHtml = default_txt ?? '';
            let iconName = '';
            if(player_self_slotNo) {
                txtHtml = !asTeam ? mg.translations.I : mg.translations.MyTeam;
                iconName =  that.getPlayerSelfIcon();
            } else if (startlist_entry != null && !$.isEmptyObject(startlist_entry)) {
                if (startlist.GroupSizeType == 'Player') {
                    if ('Entry_Reference_ID' in startlist_entry && startlist_entry.Entry_Reference_ID > 0) {
                        let entry_player = 'Player' in startlist_entry && startlist_entry.Player.length > 0 ? startlist_entry.Player[0] : null;
                        if (entry_player != null && !$.isEmptyObject(entry_player)) {
                            iconName = 'gender-unknown'; //default
                            if ('Player_IsAnonymous' in entry_player && entry_player.Player_IsAnonymous) {
                               txtHtml = `${mg.translations.Anonymous} ${mg.translations.Anonymous}`;
                            } else if ('Player_Name' in entry_player && entry_player.Player_Name != null && entry_player.Player_Name != '') {
                                txtHtml = entry_player.Player_Name;
                                if ('Player_Gender' in entry_player) {
                                    switch (entry_player.Player_Gender) {
                                        case 0:         iconName = 'woman'; break;
                                        case 1:         iconName = 'man'; break;
                                        default: break;
                                    }
                                }
                            }
                        }
                    }

                } else if (startlist.GroupSizeType == 'Team') {
                    if ('Entry_TeamRID' in startlist_entry && startlist_entry.Entry_TeamRID > 0 && 'Team_Name' in startlist_entry) {
                        txtHtml = startlist_entry.Team_Name ?? default_txt;
                    }
                }
            }
            return (iconName != '' ? `<i class="icon icon-avatar-${iconName} ${player_self_slotNo?'icon-player-self':''}"></i>` : '') + txtHtml;
        }

        renderHoleTxt(match, disabled, that) {
            let hole_number_default_txt = '??';
            return `${mg.translations.Hole} ${( 'Match_StartHoleName' in match && (match.Match_StartHoleName?.trim()??"") !=""  ?  match.Match_StartHoleName :  ('Match_StartHole' in match ? (match.Match_StartHole ?? hole_number_default_txt) : hole_number_default_txt))}`;
        }

        renderMatchStartTimeTxt(match, multiple_start_dates, that) {
            let outputFormatStr = !multiple_start_dates ? 'HH.mm' : 'DD MMM HH.mm';
            var timeTxt = moment(match.Match_StartTime, 'YYYY-MM-DDTHH:mm:ss').format(outputFormatStr);
            return timeTxt;
        }


        renderBtn_AddMyself(startlist,match, disabled, style_as_disabled, that) {
            return match ? `
                <div class="button-wrapper-inner">
                <button ${(disabled?'disabled="1"':'')} type="button" class="btn btn-${(!style_as_disabled?'primary':'blacksqueeze')} order-lg-1" data-matchrid='${match.Match_RID}'
                    ${(!disabled? `onclick="mg.pages.competition.entry.views.selectTeeTime.tryLockSlot(${startlist.StartList_Reference_ID},${match.Match_RID});"`:'')} >${mg.translations.Add}</button>
                </div>
                ` : '';
        }
        renderBtn_RemoveMyself(startlist,match, disabled, that) {
            return match ? `
                <div class="button-wrapper-inner">
                <button ${(disabled?'disabled="1"':'')} type="button" class="btn btn-primary order-lg-1" data-matchrid='${match.Match_RID}'
                    ${(!disabled? `onclick="mg.pages.competition.entry.views.selectTeeTime.tryUnlockAnySlot(${startlist.StartList_CompetitionID});"`:'')} >${mg.translations.Remove}</button>
                </div>
                ` : '';
        }

        renderInlineMessage(txt, type) {
            return `<div class="${type}-message alert alert-${type} fade show ${type=='error'?'alert-danger':''}">
                        <i class="icon icon-info" aria-hidden="false"></i>
                        <div class="${type}-message-main-content">${txt}</div>
                    </div>`;
        }

        async tryLockSlot(startlist_rid, match_rid) {
            let that = mg.pages.competition.entry.views.selectTeeTime;
            let data = that.compEntry.data;
            
            if(that.initially_selected_match!=null && !$.isEmptyObject(that.initially_selected_match) && that.initially_selected_match.MatchRID==match_rid) {
                that.ignore_selected_match_saved_entries = false;
                that.setSelectedMatch(that.initially_selected_match);
                that.render();
                return;
            }

            var startlist = data.startlists.filter(s => s.StartList_Reference_ID == startlist_rid)?.[0];
            if (startlist != null) {
                let postData = {
                    competitionID: startlist.StartList_CompetitionID,
                    courseStartID: startlist.StartList_CourseStart_Reference_ID,
                    matchID: match_rid,
                    groupSizeType: startlist.GroupSizeType,
                    groupSize: startlist.GroupSize,
                    startList_rid : startlist.StartList_Reference_ID,
                    checksum: startlist.checksum,
                };
                let errorTxt = null;
                try {
                    that.displaySpinner();
                    const resp_data = await window.mg.ajax.postAsync('/handlers/Competition/Competition_SelectTeeTime_TryLockSlot', postData);
                    that.resetSelectedMatch(that);
                    if ('TryLockSuccess' in resp_data) {
                        let match = 'Matches' in startlist && startlist.Matches.length > 0 ? startlist.Matches.filter(m => m.Match_RID == match_rid)?.[0] : null;
                        if (resp_data.TryLockSuccess) {
                            let selected_match_obj = that.generateSelectedMatchBasisObj(match, startlist);
                            selected_match_obj.PrevMatchRID = that.initially_selected_match != null && 'MatchRID' in that.initially_selected_match ? that.initially_selected_match.MatchRID : null;
                            that.setSelectedMatch(selected_match_obj);
                            that.ignore_selected_match_saved_entries = true;
                            startlist.StartList_Locked = false;
                            if (match != null) {
                                match.Match_Locked = false;
                                match.TryLockFoundOpenSlot = true; 
                            }
                        } else {
                            //lock failed
                            switch (resp_data.TryLockFailCode) {
                                case 1:
                                    errorTxt = mg.translations.TheSelectedTeeTimeIsNotAvailable;
                                      if (match != null) {
                                          match.Match_Locked = true;
                                          match.TryLockFoundOpenSlot = false; 
                                      }
                                    startlist.StartList_Locked = false;
                                    break;
                                case 2:
                                    errorTxt = mg.translations.AllTheTeeTimesOfTheStartListAreCurrentlyLocked;
                                    startlist.StartList_Locked = true;
                                    break;
                            }
                        }
                    } else {
                        errorTxt = 'Error' in resp_data ? resp_data.Error : mg.translations.UnknownError;
                    }
                } finally {
                    that.displaySpinner(true);
                    if (errorTxt != null && errorTxt != '') {
                        let errorTitle = mg.translations.Error;
                        that.displayError(errorTitle, errorTxt); 
                    }
                   that.render();
                }
            }
        }
        async tryUnlockAnySlot(competitionID) {
            let that = mg.pages.competition.entry.views.selectTeeTime;

            let successFunc = () => {
                that.resetSelectedMatch();
                that.ignore_selected_match_saved_entries = true;
                that.render();
            };

            if (that.hasMatchSelection(that) && that.initially_selected_match != null && !$.isEmptyObject(that.initially_selected_match) && that.initially_selected_match.MatchRID == that.getSelectedMatch().MatchRID) {
                successFunc();
                return;
            }

            if (competitionID != null && competitionID > 0) {
                let postData = {
                    competitionID: competitionID
                };
                try {
                    that.displaySpinner();
                    const resp_data = await window.mg.ajax.postAsync('/handlers/Competition/Competition_SelectTeeTime_TryUnLockAnySlot', postData);
                    if ('TryUnLockAnySuccess' in resp_data && resp_data.TryUnLockAnySuccess) {
                        successFunc();
                    } else {
                        that.displayError(mg.translations.UnknownError, mg.getUnknownErrorMsg('005', that.ErrorCodeModulePrefix)); //003-005
                    }
                } finally {
                    that.displaySpinner(true);
                }
            }
        }

        displaySpinner(hide) {
            let that = mg.pages.competition.entry.views.selectTeeTime;
            hide = typeof(hide) != 'undefined' ? hide : false;
            if(!hide){
                that.spinner = mg.ui.showPleaseWaitModal();
            } else {
                that.spinner.close();
            }
        }

        displayError(title,txt) {
            mg.ui.errormodal({
                html  : `<div>${txt}</div>`,
                title :  title,
            });
        }

        foundNoCompatibleStartlist(startlists, asTeam) {
            return startlists == null || startlists.length == 0 || !startlists.reduce((found_compatible_startlist, startlist) => {
                if ('GroupSizeType' in startlist) {
                    switch (startlist.GroupSizeType) {
                        case 'Player':
                            return found_compatible_startlist || !asTeam;
                            break;
                        case 'Team':
                            return found_compatible_startlist || asTeam;
                            break;
                    }
                } else {
                    return true; //Missing GroupSizeType
                }
            }, false);
        }

        initEdit_ifRelevant(asTeam, that) {
            that.is_editing = that.getSetOfSavedEntryIDs(that).size > 0;
            if (that.is_editing) {
                if ((!('Warning' in that.compEntry.data.startlists)) && !that.hasMatchSelection(that) && !that.ignore_selected_match_saved_entries) {
                    if (that.initially_selected_match == null) {
                        that.initInitiallySelectedMatch_savedEntries(that.compEntry.data.startlists, asTeam, that);
                    }

                    if (that.initially_selected_match != null) {
                        if (asTeam && that.saved_entries_part_of_team && that.initially_selected_match.EntryTeamRID > 0) {
                            that.setSelectedMatch(that.initially_selected_match);
                        }
                        if (!asTeam) {
                            if (!that.saved_entries_part_of_team) {
                                if (that.initially_selected_match.EntryRID > 0) {
                                    that.setSelectedMatch(that.initially_selected_match);
                                }
                            } else {
                                let include_link_in_warning_to_switch_signup_method = (that.compEntry.data.competition.OnlineEntryAndPayment?.OnlineEntryMethod == 3) && that.compEntry.data.startlists.length > 0;
                                that.compEntry.data.startlists.Warning = `<p>${mg.translations.TeeTimeSelectionNoAvaliableWhenEditAsPlayerPartOfTeam}</p>`;
                                if (include_link_in_warning_to_switch_signup_method) {
                                    that.compEntry.data.startlists.Warning += that.renderLinkToSwithSignupMethod(asTeam, mg.pages.competition.entry.data.requestData.ID, that.is_editing);
                                }
                            }
                        }
                    }
                }
            }
        }
        getSetOfSavedEntryIDs(that) {
            if((that.compEntry.data.requestData.Entries?.length??0) > 0){
                return  new Set(that.compEntry.data.requestData.Entries.filter(e => 'ID' in e && (e.ID ??0) > 0).map(e => e.ID));
            }
            return new Set();
        }

        initInitiallySelectedMatch_savedEntries(startlists, asTeam, that) {
            if ((that.compEntry.data.requestData.Entries?.length??0) > 0) {
                let savedEntriesId_set =  that.getSetOfSavedEntryIDs(that);
                if (startlists != null && startlists.length > 0) {
                    startlists.forEach((startlist) => {
                        if ('Matches' in startlist && startlist.Matches.length > 0) {
                            startlist.Matches.forEach((match) => {
                                if ('Entries' in match && match.Entries.length > 0) {
                                    match.Entries.forEach((e, index) => {
                                        if ('Entry_Reference_ID' in e && savedEntriesId_set.has(e.Entry_Reference_ID)) {
                                            that.saved_entries_part_of_team = that.saved_entries_part_of_team || (('Entry_TeamRID' in e) && e.Entry_TeamRID > 0);
                                            let selected_match = that.generateSelectedMatchBasisObj(match, startlist);
                                            selected_match.EntryRID = !asTeam ? e.Entry_Reference_ID : null;
                                            selected_match.EntryTeamRID = asTeam && ('Entry_TeamRID' in e) ? e.Entry_TeamRID : null;
                                            selected_match.PrevMatchRID = match.Match_RID;
                                            if (that.initially_selected_match != null && (!(Object.entries(that.initially_selected_match).sort().toString() === (Object.entries(selected_match).sort().toString())))) { 
                                                that.saved_entries_not_all_on_same_match = true;
                                            }
                                            that.initially_selected_match = selected_match;
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            }
            if(that.saved_entries_not_all_on_same_match) {
                that.compEntry.data.startlists.Warning = mg.translations.TheTeeTimeCannotBeEditedDueToInconsistenciesInTheTeeTimes;
                that.initially_selected_match = null; 
            }
        }
       
        generateSelectedMatchBasisObj(match, startlist) {
            return {
                StartlistVersionID: startlist.StartList_Version_ID,
                MatchRID: match.Match_RID,
                CourseStartRID : startlist.StartList_CourseStart_Reference_ID,
                GroupSize: startlist.GroupSize,
                GroupSizeType : startlist.GroupSizeType,
                CompetitionID:  startlist.StartList_CompetitionID,
                StartListRID : startlist.StartList_Reference_ID,
                Checksum: startlist.checksum,
            };
        }

        renderLinkToSwithSignupMethod(asTeam, competitionID, editing) {
            let asTeamInverse = (this.compEntry.asTeam ? mg.translations.AnIndividualPlayer : mg.translations.ATeam).toLowerCase();
            let signUpMethodNewLink  = `<a href='/Competition/Entry/${competitionID}/${asTeam?'1':'2'}'>${mg.translations.StartOverAs} ${asTeamInverse}</a>`;
            let signUpMethodLinkHtml = `<p>${ editing ? mg.translations.ClickTheFollowingLinkIfYouWishToChangeEditMode : mg.translations.ClickTheFollowingLinkIfYouWishToRestartTheSignUpProcess}: ${signUpMethodNewLink}</p>
                                        <p>${mg.translations.OtherwiseYouMayClickNextBelowToContinueTheProcessOf}</p>
                                        `.replace('%Player_Or_Team_Inverse%', asTeamInverse).replace('%signing_up_or_editing_sign_up%', (editing ? mg.translations.EditingSignUp.toLowerCase() : mg.translations.SigningUp.toLowerCase()));
            return signUpMethodLinkHtml;
        }

        renderWarning_noMatchSelectionPossible(asTeam, includeLinkToSwithSignupMethod, competitionID, editing, that) {
            let signUpMethodLinkHtml = includeLinkToSwithSignupMethod ? that.renderLinkToSwithSignupMethod(asTeam, competitionID, editing) : '';
            return `<p>${mg.translations.FoundNoFirstRoundStartListOfTheCompetitionThatIsOpenForRegistration}</p>
                    <p>${signUpMethodLinkHtml}</p>  
            `.replace('%Player_Or_Team%', (this.compEntry.asTeam ? mg.translations.ATeam : mg.translations.AnIndividualPlayer).toLowerCase()); 
        }

        onBeforeLeave() {
            var that = mg.pages.competition.entry.views.selectTeeTime;
            let allowNext = that.allowNext(that);
            if (!allowNext) {
                that.displayError(mg.translations.SelectTeeTime, mg.translations.PleaseSelectATeeTimeInTheListAboveBeforeContinuing); 
            }
            if(allowNext) {
                $('#btnNext').attr('data-style-as-disabled', '0'); //remove data-attr that triggers styling of 'next' button as disabled.
            }
            return allowNext;
        }

        allowNext(that) {
            return that.hasMatchSelection(that) || that.allow_progression_without_match_selection;
        }

        updateNextBtn(that) {
            mg.pages.competition.entry.setAllowNext(true);
            let allowNext = that.allowNext(that);
            $('#btnNext').attr('data-style-as-disabled', allowNext ? '0' : '1');
        }

        hasMultipleMatchStartDates(startlists) {
            let setOfStartDates = new Set();
            if (startlists != null && startlists.length > 0) {
                startlists.forEach(startlist => {
                    if ('Matches' in startlist && startlist.Matches != null) {
                        startlist.Matches.forEach(match => {
                            if ('Match_StartTime' in match && match.Match_StartTime != null && match.Match_StartTime.length == 19) {
                                setOfStartDates.add(match.Match_StartTime.substr(0, 10));
                            }
                        })
                    }
                })
            }
            return setOfStartDates.size > 1;
        }

        getPlayerSelfIcon() {
            let entry_player_self_arr = mg.pages.competition.entry.data.requestData.Entries?.filter(e => e.IsSelf === true);
            if (entry_player_self_arr != null && entry_player_self_arr.length == 1) {
                let entry_player_self = entry_player_self_arr[0];
                if ('Gender' in entry_player_self) {
                    switch (entry_player_self.Gender) {
                        case 0:
                            return 'woman';
                        case 1:
                            return 'man';
                    }
                }
            }
            return 'gender-unknown';
        }

    } 


    class CompEntry {
        constructor(target, data, asTeam, capacity, isEdit, isPayment, isPaymentOnly, playersCanSelectTeeTime) {
            this.$target    = $(target);
            this.data       = data;
            this.asTeam     = asTeam;
            this.capacity   = capacity;
            this.isEdit     = isEdit;
            this.isPayment  = isPayment;
            this.isPaymentOnly  = isPaymentOnly;
            this.playersCanSelectTeeTime = playersCanSelectTeeTime;
            this.activeView = null;
            this.isSigningup = false;

            this.views = {
                players   : new _ViewPlayers(this),
                selectTeeTime : new _ViewSelectTeeTime(this),
                questions : new _ViewQuestions(this),
                payments  : new _ViewPayments(this),
                finish    : new _ViewFinish(this)
            };

            const $form = $('form', this.$target);

            this.validation = _.ui.validation($form)
                .removePlugin('AutoFocus')
                .removePlugin('SubmitButton')
                .updatePluginOptions('Excluded', {
                    excluded: (field, element, elements) => {
                        const isVisible = !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
                        const disabled  = element.getAttribute('disabled');

                        // flatpickr
                        if (element.getAttribute('type') === 'hidden' && element.classList.contains('flatpickr-input')) {
                            const parent          = $(element).parent()[0];
                            const parentIsVisible = !!(parent.offsetWidth || parent.offsetHeight || parent.getClientRects().length);

                            return disabled === ''
                                || disabled === 'disabled'
                                || !parentIsVisible;
                        }

                        return disabled === ''
                            || disabled === 'disabled'
                            || element.getAttribute('type') === 'hidden'
                            || !isVisible;
                    }
                })
                .updatePluginOptions('Bootstrap', {
                    rowSelector: (field, element) => {
                        const rs = $(element).attr('data-row-selector');

                        if (rs)
                            return rs;

                        return '.form-group';
                    }
                })
                .addEvent('core.form.valid', () => {

                })
                .init();
        }

        init() {
            // TODO - Move these to server
            if (1 === 1) {
                const competitionData = this.data.competition;
                const requestData     = this.data.requestData;

                this.setAllowAddPlayer(requestData);

                let clubName   = null;
                let courseName = null;

                const selfPlayer = requestData.Entries ? requestData.Entries.find((v) => v.IsSelf) : null;
                const course     = selfPlayer && competitionData.Courses && competitionData.Courses.find((v) => v.ID == selfPlayer.CourseID);
                this.isSignedUp  = selfPlayer && selfPlayer.ID !== null && selfPlayer.ID !== undefined; // oMG used the EntrySignupStatus enum that is retrieved from GBTour to determine whether the user is already signed up, but something tells me this will do just fine
            }

            var initAction = 'players';

            if (this.isPayment) {
                initAction = 'payments';
            }

            this.show(initAction);
        }

        show(identifier, initRender = true) {
            const view = this.views[identifier];

            if (view) {
                $('.entry-view.active', this.$target).removeClass('active');

                this.activeView = view;

                if ((initRender || !view.rendered) && view.render) {
                    view.render();
                    view.rendered = true;
                }

                $('#comp-entry-view-' + identifier, this.$target).addClass('active');
                this.updateNextText();
                this.updatePrevState();

                if (identifier === 'finish') {
                    $('#comp-entry-finish-ad-wrapper .advertising-content').html(mg.renderThankYouPageAd());
                }
            }
        }

        resolveNextStep() {
            return this.resolveStep('next');
        }

        resolvePrevStep() {
            return this.resolveStep('prev');
        }

        resolveStep(direction) {
            const steps = [
                'players',
                'selectTeeTime',
                'questions',
                'payments',
                'paymentWindow',
                'signup',
                'finish'
            ];

            const currentStepIndex = this.activeView && steps.findIndex((v) => this.views.hasOwnProperty(v) && this.activeView === this.views[v]);

            const hasQuestions = this.data.requestData.Entries.some((v) => {
                var $rqTemplates = $('.request-templates').children();
                var hasTemplates = $rqTemplates.length > 0;

                if (hasTemplates && !this.asTeam && $rqTemplates.filter('[data-type!="team"]').length === 0) // If everything is for team and we're not signing up as team, this step should be skipped.
                    hasTemplates = false;

                return hasTemplates;
            });

            const that = this;
            const hasQuestionAnswerWithPrice = (v, participantIdentifier) => {
                var result = false;

                v.Questions && v.Questions.length && $.each(v.Questions, function (kQ, vQ) {
                    var answer = that.views.questions._getQuestionAnswer(vQ.Info.ID, vQ.Info.TypeOf, participantIdentifier);

                    if (answer) {
                        var product = that.views.questions._getProduct(vQ, answer, participantIdentifier);

                        if (product) {
                            result = true;
                            return false; // Break the loop
                        }
                    }
                });

                return result;
            };

            const hasPayments = this.data.requestData.Entries.some((v) => {
                return v.Products.some((vP) => vP.Price > 0) || hasQuestionAnswerWithPrice(v, v.MemberID);
            }) || this.data.requestData.Teams.some((v) => {
                return v.Products.some((vP) => vP.Price > 0) || hasQuestionAnswerWithPrice(v, 'team');
            });

            for (let i = 0; i < steps.length; i++) {
                const step = steps[i];
                let isRelevant = false;

                switch (step) {
                    case 'players':
                        isRelevant = true;
                        break;
                    case 'selectTeeTime':
                        isRelevant =  this.playersCanSelectTeeTime;
                        break;
                    case 'questions':
                        isRelevant = hasQuestions;
                        break;
                    case 'payments':
                        isRelevant = hasPayments;
                        break;
                    case 'paymentWindow':
                        isRelevant = hasPayments && that.views.payments.getPayNowProducts().length > 0;
                        break;
                    case 'signup':
                        isRelevant = true;
                        break;
                    case 'finish':
                        isRelevant = true;
                        break;
                }

                steps[i] = { id: step, isRelevant: isRelevant };
            }

            if (direction === 'prev') {
                let prevStep = null;

                for (let i = currentStepIndex - 1; i >= 0; i--) {
                    let step = steps[i];

                    if (step.isRelevant) {
                        prevStep = step.id;
                        break;
                    }
                }

                return prevStep;
            }

            let nextStep = null;

            for (let i = currentStepIndex + 1; i < steps.length; i++) {
                let step = steps[i];

                if (step.isRelevant) {
                    nextStep = step.id;
                    break;
                }
            }

            return nextStep;
        }

        prev() {
            const prevStep = this.resolvePrevStep();

            if (prevStep) {
                $('#btnNext').attr('data-style-as-disabled','0');
                this.validation.fv.resetForm();
                this.show(prevStep, false);
            }
        }

        next(onBeforeLeaveConfirmed) {
            const cloneFields   = $.extend(true, {}, this.validation.fv.fields);
            const excludeFields = Object.keys(cloneFields)
                .filter((v) => {
                    return [
                        'ddl-addplayer-favs',
                        'txt-addplayer-golfid',
                        'txt-addplayer-firstname',
                        'txt-addplayer-lastname'
                    ].indexOf(v) === -1;
                });

            this.validation.fv.fields = Object.assign({}, ...excludeFields.map((v) => ({ [v]: cloneFields[v] })));

            this.validation.fv
                .validate()
                .then((status) => {
                    this.validation.fv.fields = Object.assign(cloneFields, this.validation.fv.fields);

                    if (status === FormValidation.Status.NotValidated || status === FormValidation.Status.Invalid)
                        return;

                    const nextStep = this.resolveNextStep();

                    if (nextStep) {
                        if (this.activeView && $.isFunction(this.activeView.validate) && this.activeView.validate() === false) {
                            return;
                        }

                        if (!onBeforeLeaveConfirmed && this.activeView && $.isFunction(this.activeView.onBeforeLeave) && this.activeView.onBeforeLeave() === false) { // Views can return false here to indicate that the user needs to confirm something before we can continue
                            return;
                        }

                        if (nextStep === 'paymentWindow' || nextStep === 'signup') {
                            var that = this;

                            (function (that, nextStep) {
                                that.preSignup(function () {
                                    if (nextStep === 'paymentWindow') {
                                        that.showPaymentWindow();
                                    } else if (nextStep === 'signup') {
                                        that.signup();
                                    }
                                });
                            })(that, nextStep);
                        } else {
                            this.show(nextStep);
                        }
                    }
                });
        }

        cancel() {
            this.$target.parents('.overlay').find('.overlay-header-close').trigger('click');
        }

        updateNextText() {
            const nextStep = this.resolveNextStep();

            if (nextStep) {
                let btnNextText = _.translations.Next;

                if (nextStep === 'paymentWindow' || this.isPaymentOnly) {
                    btnNextText = _.translations.Pay;
                } else if (nextStep === 'signup') {
                    btnNextText = this.isEdit ? _.translations.EditSignUp : _.translations.SignUp;
                }

                $('#btnNext', this.$target).html(btnNextText);
            }
        }

        updatePrevState() {
            $('#btnPrev').toggle(this.activeView && (!this.activeView.$wrapper || this.activeView.$wrapper.attr('id') !== 'comp-entry-view-players')); // Not shown on the first step
        }

        setAllowNext(allowNext) {
            $('#btnNext').toggleClass('btn-primary', allowNext).toggleClass('disabled', !allowNext).prop('disabled', !allowNext);
        }

        getSignupData() {
            return { data: _.url.encode(JSON.stringify(this.data.requestData)), asTeam: this.asTeam };
        }

        preSignup(callback) {
            var warnings = [];

            // KJ 2019-09-27: Moved the "max competitors reached" check to the onBeforeLeave of the first view, in order for that warning to be shown as quickly as possible. I decided to keep this logic here, even though it doesn't show any warnings at the moment, just in case we ever want to add a warning before the signup again

            if (warnings.length > 0) {
                _.ui.confirmmodal({ title: _.translations.MaximumParticipantsReached, html: '<div>' + warnings.join('\n') + '</div>', btnYesOnClick: callback, useOKCancel: true });
            }
            else {
                callback();
            }
        }

        signup() {
            const pleaseWaitModal = _.ui.showPleaseWaitModal({
                onClose: () => { }
            });

            if (this.isSigningup)
                return;
            this.isSigningup = true;

            _.ajax.post('?handler=Signup', this.getSignupData() ).done((data) => {
                var errorMessage = data ? data.ErrorMessage : _.translations.UnknownError;

                if (errorMessage) {
                    this.isSigningup = false;
                    pleaseWaitModal.close();
                    mg.showErrorModal(mg.translations.Error, mg.resolveError(errorMessage));
                }
                else {
                    pleaseWaitModal.close();
                    this.show('finish');
                }
            });
        }

        showPaymentWindow() {
            var that = this;
            var paymentWindow = _.payment.open({
                id: '', callBackOnClose: function (paymentComplete) {
                    if (paymentComplete) {
                        that.show('finish');
                    }
                }
            });

            let selectedProducts = this.views.payments.getPayNowProducts();
            let payNow = [];

            $.each(selectedProducts, (k, v) => {
                var ids = v.id.split('_');
                payNow.push(ids.slice(ids.length - 2).join('_'));
            });

            var signupData = this.getSignupData();
            let postData = $.extend({
                payNow: payNow
            }, signupData);

            _.ajax.post('?handler=CreatePayment', postData).done(function (data) {
                _.gaEvent('Payment_initiated', 'Payment', data.ErrorMessage ? data.ErrorMessage : data.PaymentID, function () {
                    if (data.ErrorMessage) {
                        var errorMessage = mg.resolveError(data.ErrorMessage, true); // We set requireMatch: true here, as we only want to show error messages we could identify.
                        mg.showErrorModal(mg.translations.UnableToContinue, errorMessage || mg.translations.UnknownError);
                        paymentWindow && paymentWindow.close();
                    } else {
                        _.payment.navigate('', data.PaymentID, paymentWindow);
                    }
                });
            });
        }

        validateFields(fields) {
            return Promise
                .all(fields.map((v) => this.validation.fv.validateField(v)))
                .then((results) => {
                    if (results.indexOf(FormValidation.Status.Invalid) !== -1)
                        return Promise.resolve(FormValidation.Status.Invalid);

                    if (results.indexOf(FormValidation.Status.NotValidated) !== -1)
                        return Promise.resolve(FormValidation.Status.NotValidated);

                    return Promise.resolve(FormValidation.Status.Valid);
                });
        }

        setAllowAddPlayer(data) {
            let allowAddPlayer = this.capacity > data.Entries.length;
            $('.add-player').toggle(allowAddPlayer);
        }

        static ddlQuestionOnChange(element) {
            var $element = $(element);
            var $option = $element.find('option[value="' + $element.val() + '"]');
            var $parent = $element.parents('.row');

            if ($parent) {
                var price = $option.attr('data-price');
                var priceTokens = price ? price.split(';') : [];

                $parent.find('> div:nth-child(2)').html(priceTokens.length > 1 ? _.cc.formatAmount(priceTokens[0], true) + ' ' + priceTokens[1] : '');
            }
        }

        static onChkAcceptRequiredClick(element) {
            var $element = $(element);
            var disabledReason = $element.attr('data-disabled-reason');

            if (disabledReason) {
                var errorMessage = mg.resolveError(disabledReason);
                mg.showErrorModal(mg.translations.InsufficientRights, errorMessage);
                $element.prop('checked', false); // Make sure the user can't set this checkbox to checked (the preventDefault should cover it, so this is just an extra safeguard that may not be necessary).
                event && event.preventDefault(); // Make sure the user can't set this checkbox to checked.
                return;
            }
        }
    }

    _.competitionEntry = CompEntry;
})(jQuery, window);
